export const Localize = {
    "en_GB": {
        "contacts": "Contacts",
        "contacts_subtitle": "Manage your company address book",
        "import": "Import",
        "export": "Export",
        "add_contact": "Add Contact",
        "import_contacts": "Import Contacts",
        "type_to_search": "Type to search",
        "all": "All",
        "name": "Name",
        "phone": "Phone",
        "email": "Email",
        "company": "Company",
        "notes": "Notes",
        "today": "Today",
        "this_week": "This Week",
        "this_month": "This Month",
        "this_year": "This Year",
        "filters": "Filters",
        "filter_by": "Filter by",
        "reset_filters": "Reset filters",
        "status": "Status",
        "all_contacts": "All Contacts",
        "favorites_only": "Favorites Only",
        "created": "Created",
        "created_at": "Created At",
        "actions": "Actions",
        "bulk_actions": "Bulk Actions",
        "add_to_favorites": "Add to Favorites",
        "remove_from_favorites": "Remove from Favorites",
        "delete": "Delete",
        "delete_contact": "Delete Contact",
        "delete_contacts": "Delete Contacts",
        "cancel": "Cancel",
        "invite": "Invite",
        "view_details": "View Details",
        "edit_contact": "Edit Contact",
        "not_available": "N/A",
        "just_now": "Just now",
        "no_contacts_yet": "No contacts yet",
        "empty_desc_can_add": "Add your first contact or import from a CSV file",
        "empty_desc_view_only": "No contacts have been added yet",
        "favorites": "Favorites",
        "show": "Show",
        "rows": "rows",
        "no_favorites": "No favorites",
        "no_favorites_yet": "No favorite contacts yet. Mark contacts as favorites for quick access.",
        "no_contacts_found": "No contacts found",
        "all_are_favorites": "All contacts are marked as favorites.",
        "confirm_delete_named": "Are you sure you want to delete {name} contact?",
        "confirm_add_fav_named": "Are you sure you want to add {name} to favorites?",
        "confirm_remove_fav_named": "Are you sure you want to remove {name} from favorites?",
        "contact_deleted": "Contact deleted",
        "error_occurred": "An error occurred",
        "added_to_favorites": "Added to favorites",
        "removed_from_favorites": "Removed from favorites",
        "export_failed": "Export failed",
        "contact_added": "Contact added",
        "contact_updated": "Contact updated",
        "contacts_imported": "Contacts imported",
        "required_field": "Required field",
        "enter_name": "Enter name",
        "enter_company": "Enter company",
        "enter_phone": "Enter phone",
        "enter_email": "Enter email",
        "notes_placeholder": "Add notes about this contact...",
        "mark_as_favorite": "Mark as Favorite",
        "add_another_after_save": "Add another contact after saving",
        "save_changes": "Save Changes",
        "name_required": "Name is required",
        "name_min_length": "Name must be at least 1 character",
        "max_chars": "Up to {n} characters allowed",
        "invalid_email": "Invalid email address",
        "invalid_phone": "Invalid phone number",
        "phone_or_email_required": "Phone or Email is required",
        "contact_details": "Contact Details",
        "label_copied": "{label} copied",
        "close": "Close",
        "change": "Change",
        "select_from_contacts": "Select from Contacts",
        "choose_contact_desc": "Choose a contact from your address book",
        "select_contact_title": "Select Contact",
        "picker_search_email": "Search contacts or enter email...",
        "picker_search_phone": "Search contacts or enter phone number...",
        "loading_contacts": "Loading contacts...",
        "no_contacts_found_for": "No contacts found for \"{value}\"",
        "no_contacts_available": "No contacts available",
        "loading_more": "Loading more...",
        "add_new_contact": "Add New Contact",
        "continue": "Continue",
        "invalid_file_type": "Invalid file type. Please upload an Excel (.xlsx) or CSV (.csv) file.",
        "file_too_large": "File is too large. Maximum size is {n}MB.",
        "import_failed": "Import failed. Please try again.",
        "total": "Total",
        "imported": "Imported",
        "failed": "Failed",
        "row": "Row",
        "reason": "Reason",
        "none_imported": "No contacts were imported. Please check your file and try again.",
        "done": "Done",
        "how_to_import": "How to import contacts",
        "import_step_template": "Download our CSV template to ensure proper formatting",
        "import_step_required": "Required fields: Full Name, Phone Number or Email",
        "import_step_phone": "If Phone Number is provided: Country Code and Country Iso are also required",
        "import_step_optional": "Optional fields: Company, Notes",
        "import_step_max_size": "Maximum file size: {n}MB (approximately 10,000 contacts)",
        "drop_title": "Drag and drop your CSV file here",
        "drop_or": "or",
        "browse_files": "browse files",
        "kb": "KB",
        "need_template": "Need a template?",
        "download_template": "Download CSV Template",
        "feature_not_enabled_title": "Contacts Management feature is not enabled",
        "feature_not_enabled_desc": "Store customer details in a shared address book and quickly invite contacts to sessions. Request your admin to enable this feature.",
        "learn_more": "Learn more",
        "features_title": "Contacts management features",
        "feature_shared_title": "Shared Address Book",
        "feature_shared_desc": "Store And Access Customer Details Across Your Team",
        "feature_invites_title": "Quick Invites",
        "feature_invites_desc": "Select Contacts During Session Creation With Auto-Fill",
        "n_selected": "{n} selected",
        "one_selected": "{n} selected",
        "confirm_delete_contacts": "Are you sure you want to delete {n} contacts?",
        "confirm_delete_one_contact": "Are you sure you want to delete {n} contact?",
        "confirm_add_fav_contacts": "Are you sure you want to add {n} contacts to favorites?",
        "confirm_add_fav_one_contact": "Are you sure you want to add {n} contact to favorites?",
        "confirm_remove_fav_contacts": "Are you sure you want to remove {n} contacts from favorites?",
        "confirm_remove_fav_one_contact": "Are you sure you want to remove {n} contact from favorites?",
        "contacts_deleted": "{n} contacts deleted",
        "one_contact_deleted": "{n} contact deleted",
        "contacts_exported": "{n} contacts exported",
        "one_contact_exported": "{n} contact exported",
        "rows_not_imported": "{n} rows could not be imported",
        "one_row_not_imported": "{n} row could not be imported",
        "minutes_ago": "{n} mins ago",
        "hours_ago": "{n} hours ago",
        "one_hour_ago": "{n} hour ago",
        "days_ago": "{n} days ago",
        "one_day_ago": "{n} day ago",
        "weeks_ago": "{n} weeks ago",
        "one_week_ago": "{n} week ago"
    },
    "de_DE": {
        "contacts": "Kontakte",
        "contacts_subtitle": "Verwalten Sie das Adressbuch Ihres Unternehmens",
        "import": "Importieren",
        "export": "Exportieren",
        "add_contact": "Kontakt hinzufügen",
        "import_contacts": "Kontakte importieren",
        "type_to_search": "Suchbegriff eingeben",
        "all": "Alle",
        "name": "Name",
        "phone": "Telefon",
        "email": "E-Mail",
        "company": "Unternehmen",
        "notes": "Notizen",
        "today": "Heute",
        "this_week": "Diese Woche",
        "this_month": "Dieser Monat",
        "this_year": "Dieses Jahr",
        "filters": "Filter",
        "filter_by": "Filtern nach",
        "reset_filters": "Filter zurücksetzen",
        "status": "Status",
        "all_contacts": "Alle Kontakte",
        "favorites_only": "Nur Favoriten",
        "created": "Erstellt",
        "created_at": "Erstellt am",
        "actions": "Aktionen",
        "bulk_actions": "Sammelaktionen",
        "add_to_favorites": "Zu Favoriten hinzufügen",
        "remove_from_favorites": "Aus Favoriten entfernen",
        "delete": "Löschen",
        "delete_contact": "Kontakt löschen",
        "delete_contacts": "Kontakte löschen",
        "cancel": "Abbrechen",
        "invite": "Einladen",
        "view_details": "Details anzeigen",
        "edit_contact": "Kontakt bearbeiten",
        "not_available": "k. A.",
        "just_now": "Gerade eben",
        "no_contacts_yet": "Noch keine Kontakte",
        "empty_desc_can_add": "Fügen Sie Ihren ersten Kontakt hinzu oder importieren Sie eine CSV-Datei",
        "empty_desc_view_only": "Es wurden noch keine Kontakte hinzugefügt",
        "favorites": "Favoriten",
        "show": "Anzeigen",
        "rows": "Zeilen",
        "no_favorites": "Keine Favoriten",
        "no_favorites_yet": "Noch keine Favoriten. Markieren Sie Kontakte als Favoriten, um schnell darauf zuzugreifen.",
        "no_contacts_found": "Keine Kontakte gefunden",
        "all_are_favorites": "Alle Kontakte sind als Favoriten markiert.",
        "confirm_delete_named": "Möchten Sie den Kontakt {name} wirklich löschen?",
        "confirm_add_fav_named": "Möchten Sie {name} wirklich zu den Favoriten hinzufügen?",
        "confirm_remove_fav_named": "Möchten Sie {name} wirklich aus den Favoriten entfernen?",
        "contact_deleted": "Kontakt gelöscht",
        "error_occurred": "Ein Fehler ist aufgetreten",
        "added_to_favorites": "Zu Favoriten hinzugefügt",
        "removed_from_favorites": "Aus Favoriten entfernt",
        "export_failed": "Export fehlgeschlagen",
        "contact_added": "Kontakt hinzugefügt",
        "contact_updated": "Kontakt aktualisiert",
        "contacts_imported": "Kontakte importiert",
        "required_field": "Pflichtfeld",
        "enter_name": "Name eingeben",
        "enter_company": "Unternehmen eingeben",
        "enter_phone": "Telefonnummer eingeben",
        "enter_email": "E-Mail eingeben",
        "notes_placeholder": "Notizen zu diesem Kontakt hinzufügen...",
        "mark_as_favorite": "Als Favorit markieren",
        "add_another_after_save": "Nach dem Speichern weiteren Kontakt hinzufügen",
        "save_changes": "Änderungen speichern",
        "name_required": "Name ist erforderlich",
        "name_min_length": "Der Name muss mindestens 1 Zeichen lang sein",
        "max_chars": "Bis zu {n} Zeichen erlaubt",
        "invalid_email": "Ungültige E-Mail-Adresse",
        "invalid_phone": "Ungültige Telefonnummer",
        "phone_or_email_required": "Telefon oder E-Mail ist erforderlich",
        "contact_details": "Kontaktdetails",
        "label_copied": "{label} kopiert",
        "close": "Schließen",
        "change": "Ändern",
        "select_from_contacts": "Aus Kontakten auswählen",
        "choose_contact_desc": "Wählen Sie einen Kontakt aus Ihrem Adressbuch",
        "select_contact_title": "Kontakt auswählen",
        "picker_search_email": "Kontakte suchen oder E-Mail eingeben...",
        "picker_search_phone": "Kontakte suchen oder Telefonnummer eingeben...",
        "loading_contacts": "Kontakte werden geladen...",
        "no_contacts_found_for": "Keine Kontakte für „{value}“ gefunden",
        "no_contacts_available": "Keine Kontakte verfügbar",
        "loading_more": "Weitere werden geladen...",
        "add_new_contact": "Neuen Kontakt hinzufügen",
        "continue": "Weiter",
        "invalid_file_type": "Ungültiger Dateityp. Bitte laden Sie eine Excel-Datei (.xlsx) oder CSV-Datei (.csv) hoch.",
        "file_too_large": "Die Datei ist zu groß. Die maximale Größe beträgt {n} MB.",
        "import_failed": "Import fehlgeschlagen. Bitte versuchen Sie es erneut.",
        "total": "Gesamt",
        "imported": "Importiert",
        "failed": "Fehlgeschlagen",
        "row": "Zeile",
        "reason": "Grund",
        "none_imported": "Es wurden keine Kontakte importiert. Bitte überprüfen Sie Ihre Datei und versuchen Sie es erneut.",
        "done": "Fertig",
        "how_to_import": "So importieren Sie Kontakte",
        "import_step_template": "Laden Sie unsere CSV-Vorlage herunter, um die richtige Formatierung sicherzustellen",
        "import_step_required": "Pflichtfelder: Vollständiger Name, Telefonnummer oder E-Mail",
        "import_step_phone": "Wenn eine Telefonnummer angegeben ist, sind auch Ländervorwahl und Länder-ISO-Code erforderlich",
        "import_step_optional": "Optionale Felder: Unternehmen, Notizen",
        "import_step_max_size": "Maximale Dateigröße: {n} MB (ca. 10.000 Kontakte)",
        "drop_title": "Ziehen Sie Ihre CSV-Datei hierher",
        "drop_or": "oder",
        "browse_files": "Dateien durchsuchen",
        "kb": "KB",
        "need_template": "Benötigen Sie eine Vorlage?",
        "download_template": "CSV-Vorlage herunterladen",
        "feature_not_enabled_title": "Die Funktion Kontaktverwaltung ist nicht aktiviert",
        "feature_not_enabled_desc": "Speichern Sie Kundendaten in einem gemeinsamen Adressbuch und laden Sie Kontakte schnell zu Sitzungen ein. Bitten Sie Ihren Administrator, diese Funktion zu aktivieren.",
        "learn_more": "Mehr erfahren",
        "features_title": "Funktionen der Kontaktverwaltung",
        "feature_shared_title": "Gemeinsames Adressbuch",
        "feature_shared_desc": "Kundendaten im gesamten Team speichern und abrufen",
        "feature_invites_title": "Schnelle Einladungen",
        "feature_invites_desc": "Kontakte beim Erstellen einer Sitzung mit automatischem Ausfüllen auswählen",
        "n_selected": "{n} ausgewählt",
        "one_selected": "{n} ausgewählt",
        "confirm_delete_contacts": "Möchten Sie {n} Kontakte wirklich löschen?",
        "confirm_delete_one_contact": "Möchten Sie {n} Kontakt wirklich löschen?",
        "confirm_add_fav_contacts": "Möchten Sie {n} Kontakte wirklich zu den Favoriten hinzufügen?",
        "confirm_add_fav_one_contact": "Möchten Sie {n} Kontakt wirklich zu den Favoriten hinzufügen?",
        "confirm_remove_fav_contacts": "Möchten Sie {n} Kontakte wirklich aus den Favoriten entfernen?",
        "confirm_remove_fav_one_contact": "Möchten Sie {n} Kontakt wirklich aus den Favoriten entfernen?",
        "contacts_deleted": "{n} Kontakte gelöscht",
        "one_contact_deleted": "{n} Kontakt gelöscht",
        "contacts_exported": "{n} Kontakte exportiert",
        "one_contact_exported": "{n} Kontakt exportiert",
        "rows_not_imported": "{n} Zeilen konnten nicht importiert werden",
        "one_row_not_imported": "{n} Zeile konnte nicht importiert werden",
        "minutes_ago": "vor {n} Min.",
        "hours_ago": "vor {n} Stunden",
        "one_hour_ago": "vor {n} Stunde",
        "days_ago": "vor {n} Tagen",
        "one_day_ago": "vor {n} Tag",
        "weeks_ago": "vor {n} Wochen",
        "one_week_ago": "vor {n} Woche"
    },
    "en_US": {
        "contacts": "Contacts",
        "contacts_subtitle": "Manage your company address book",
        "import": "Import",
        "export": "Export",
        "add_contact": "Add Contact",
        "import_contacts": "Import Contacts",
        "type_to_search": "Type to search",
        "all": "All",
        "name": "Name",
        "phone": "Phone",
        "email": "Email",
        "company": "Company",
        "notes": "Notes",
        "today": "Today",
        "this_week": "This Week",
        "this_month": "This Month",
        "this_year": "This Year",
        "filters": "Filters",
        "filter_by": "Filter by",
        "reset_filters": "Reset filters",
        "status": "Status",
        "all_contacts": "All Contacts",
        "favorites_only": "Favorites Only",
        "created": "Created",
        "created_at": "Created At",
        "actions": "Actions",
        "bulk_actions": "Bulk Actions",
        "add_to_favorites": "Add to Favorites",
        "remove_from_favorites": "Remove from Favorites",
        "delete": "Delete",
        "delete_contact": "Delete Contact",
        "delete_contacts": "Delete Contacts",
        "cancel": "Cancel",
        "invite": "Invite",
        "view_details": "View Details",
        "edit_contact": "Edit Contact",
        "not_available": "N/A",
        "just_now": "Just now",
        "no_contacts_yet": "No contacts yet",
        "empty_desc_can_add": "Add your first contact or import from a CSV file",
        "empty_desc_view_only": "No contacts have been added yet",
        "favorites": "Favorites",
        "show": "Show",
        "rows": "rows",
        "no_favorites": "No favorites",
        "no_favorites_yet": "No favorite contacts yet. Mark contacts as favorites for quick access.",
        "no_contacts_found": "No contacts found",
        "all_are_favorites": "All contacts are marked as favorites.",
        "confirm_delete_named": "Are you sure you want to delete {name} contact?",
        "confirm_add_fav_named": "Are you sure you want to add {name} to favorites?",
        "confirm_remove_fav_named": "Are you sure you want to remove {name} from favorites?",
        "contact_deleted": "Contact deleted",
        "error_occurred": "An error occurred",
        "added_to_favorites": "Added to favorites",
        "removed_from_favorites": "Removed from favorites",
        "export_failed": "Export failed",
        "contact_added": "Contact added",
        "contact_updated": "Contact updated",
        "contacts_imported": "Contacts imported",
        "required_field": "Required field",
        "enter_name": "Enter name",
        "enter_company": "Enter company",
        "enter_phone": "Enter phone",
        "enter_email": "Enter email",
        "notes_placeholder": "Add notes about this contact...",
        "mark_as_favorite": "Mark as Favorite",
        "add_another_after_save": "Add another contact after saving",
        "save_changes": "Save Changes",
        "name_required": "Name is required",
        "name_min_length": "Name must be at least 1 character",
        "max_chars": "Up to {n} characters allowed",
        "invalid_email": "Invalid email address",
        "invalid_phone": "Invalid phone number",
        "phone_or_email_required": "Phone or Email is required",
        "contact_details": "Contact Details",
        "label_copied": "{label} copied",
        "close": "Close",
        "change": "Change",
        "select_from_contacts": "Select from Contacts",
        "choose_contact_desc": "Choose a contact from your address book",
        "select_contact_title": "Select Contact",
        "picker_search_email": "Search contacts or enter email...",
        "picker_search_phone": "Search contacts or enter phone number...",
        "loading_contacts": "Loading contacts...",
        "no_contacts_found_for": "No contacts found for \"{value}\"",
        "no_contacts_available": "No contacts available",
        "loading_more": "Loading more...",
        "add_new_contact": "Add New Contact",
        "continue": "Continue",
        "invalid_file_type": "Invalid file type. Please upload an Excel (.xlsx) or CSV (.csv) file.",
        "file_too_large": "File is too large. Maximum size is {n}MB.",
        "import_failed": "Import failed. Please try again.",
        "total": "Total",
        "imported": "Imported",
        "failed": "Failed",
        "row": "Row",
        "reason": "Reason",
        "none_imported": "No contacts were imported. Please check your file and try again.",
        "done": "Done",
        "how_to_import": "How to import contacts",
        "import_step_template": "Download our CSV template to ensure proper formatting",
        "import_step_required": "Required fields: Full Name, Phone Number or Email",
        "import_step_phone": "If Phone Number is provided: Country Code and Country Iso are also required",
        "import_step_optional": "Optional fields: Company, Notes",
        "import_step_max_size": "Maximum file size: {n}MB (approximately 10,000 contacts)",
        "drop_title": "Drag and drop your CSV file here",
        "drop_or": "or",
        "browse_files": "browse files",
        "kb": "KB",
        "need_template": "Need a template?",
        "download_template": "Download CSV Template",
        "feature_not_enabled_title": "Contacts Management feature is not enabled",
        "feature_not_enabled_desc": "Store customer details in a shared address book and quickly invite contacts to sessions. Request your admin to enable this feature.",
        "learn_more": "Learn more",
        "features_title": "Contacts management features",
        "feature_shared_title": "Shared Address Book",
        "feature_shared_desc": "Store And Access Customer Details Across Your Team",
        "feature_invites_title": "Quick Invites",
        "feature_invites_desc": "Select Contacts During Session Creation With Auto-Fill",
        "n_selected": "{n} selected",
        "one_selected": "{n} selected",
        "confirm_delete_contacts": "Are you sure you want to delete {n} contacts?",
        "confirm_delete_one_contact": "Are you sure you want to delete {n} contact?",
        "confirm_add_fav_contacts": "Are you sure you want to add {n} contacts to favorites?",
        "confirm_add_fav_one_contact": "Are you sure you want to add {n} contact to favorites?",
        "confirm_remove_fav_contacts": "Are you sure you want to remove {n} contacts from favorites?",
        "confirm_remove_fav_one_contact": "Are you sure you want to remove {n} contact from favorites?",
        "contacts_deleted": "{n} contacts deleted",
        "one_contact_deleted": "{n} contact deleted",
        "contacts_exported": "{n} contacts exported",
        "one_contact_exported": "{n} contact exported",
        "rows_not_imported": "{n} rows could not be imported",
        "one_row_not_imported": "{n} row could not be imported",
        "minutes_ago": "{n} mins ago",
        "hours_ago": "{n} hours ago",
        "one_hour_ago": "{n} hour ago",
        "days_ago": "{n} days ago",
        "one_day_ago": "{n} day ago",
        "weeks_ago": "{n} weeks ago",
        "one_week_ago": "{n} week ago"
    },
    "en_AU": {
        "contacts": "Contacts",
        "contacts_subtitle": "Manage your company address book",
        "import": "Import",
        "export": "Export",
        "add_contact": "Add Contact",
        "import_contacts": "Import Contacts",
        "type_to_search": "Type to search",
        "all": "All",
        "name": "Name",
        "phone": "Phone",
        "email": "Email",
        "company": "Company",
        "notes": "Notes",
        "today": "Today",
        "this_week": "This Week",
        "this_month": "This Month",
        "this_year": "This Year",
        "filters": "Filters",
        "filter_by": "Filter by",
        "reset_filters": "Reset filters",
        "status": "Status",
        "all_contacts": "All Contacts",
        "favorites_only": "Favorites Only",
        "created": "Created",
        "created_at": "Created At",
        "actions": "Actions",
        "bulk_actions": "Bulk Actions",
        "add_to_favorites": "Add to Favorites",
        "remove_from_favorites": "Remove from Favorites",
        "delete": "Delete",
        "delete_contact": "Delete Contact",
        "delete_contacts": "Delete Contacts",
        "cancel": "Cancel",
        "invite": "Invite",
        "view_details": "View Details",
        "edit_contact": "Edit Contact",
        "not_available": "N/A",
        "just_now": "Just now",
        "no_contacts_yet": "No contacts yet",
        "empty_desc_can_add": "Add your first contact or import from a CSV file",
        "empty_desc_view_only": "No contacts have been added yet",
        "favorites": "Favorites",
        "show": "Show",
        "rows": "rows",
        "no_favorites": "No favorites",
        "no_favorites_yet": "No favorite contacts yet. Mark contacts as favorites for quick access.",
        "no_contacts_found": "No contacts found",
        "all_are_favorites": "All contacts are marked as favorites.",
        "confirm_delete_named": "Are you sure you want to delete {name} contact?",
        "confirm_add_fav_named": "Are you sure you want to add {name} to favorites?",
        "confirm_remove_fav_named": "Are you sure you want to remove {name} from favorites?",
        "contact_deleted": "Contact deleted",
        "error_occurred": "An error occurred",
        "added_to_favorites": "Added to favorites",
        "removed_from_favorites": "Removed from favorites",
        "export_failed": "Export failed",
        "contact_added": "Contact added",
        "contact_updated": "Contact updated",
        "contacts_imported": "Contacts imported",
        "required_field": "Required field",
        "enter_name": "Enter name",
        "enter_company": "Enter company",
        "enter_phone": "Enter phone",
        "enter_email": "Enter email",
        "notes_placeholder": "Add notes about this contact...",
        "mark_as_favorite": "Mark as Favorite",
        "add_another_after_save": "Add another contact after saving",
        "save_changes": "Save Changes",
        "name_required": "Name is required",
        "name_min_length": "Name must be at least 1 character",
        "max_chars": "Up to {n} characters allowed",
        "invalid_email": "Invalid email address",
        "invalid_phone": "Invalid phone number",
        "phone_or_email_required": "Phone or Email is required",
        "contact_details": "Contact Details",
        "label_copied": "{label} copied",
        "close": "Close",
        "change": "Change",
        "select_from_contacts": "Select from Contacts",
        "choose_contact_desc": "Choose a contact from your address book",
        "select_contact_title": "Select Contact",
        "picker_search_email": "Search contacts or enter email...",
        "picker_search_phone": "Search contacts or enter phone number...",
        "loading_contacts": "Loading contacts...",
        "no_contacts_found_for": "No contacts found for \"{value}\"",
        "no_contacts_available": "No contacts available",
        "loading_more": "Loading more...",
        "add_new_contact": "Add New Contact",
        "continue": "Continue",
        "invalid_file_type": "Invalid file type. Please upload an Excel (.xlsx) or CSV (.csv) file.",
        "file_too_large": "File is too large. Maximum size is {n}MB.",
        "import_failed": "Import failed. Please try again.",
        "total": "Total",
        "imported": "Imported",
        "failed": "Failed",
        "row": "Row",
        "reason": "Reason",
        "none_imported": "No contacts were imported. Please check your file and try again.",
        "done": "Done",
        "how_to_import": "How to import contacts",
        "import_step_template": "Download our CSV template to ensure proper formatting",
        "import_step_required": "Required fields: Full Name, Phone Number or Email",
        "import_step_phone": "If Phone Number is provided: Country Code and Country Iso are also required",
        "import_step_optional": "Optional fields: Company, Notes",
        "import_step_max_size": "Maximum file size: {n}MB (approximately 10,000 contacts)",
        "drop_title": "Drag and drop your CSV file here",
        "drop_or": "or",
        "browse_files": "browse files",
        "kb": "KB",
        "need_template": "Need a template?",
        "download_template": "Download CSV Template",
        "feature_not_enabled_title": "Contacts Management feature is not enabled",
        "feature_not_enabled_desc": "Store customer details in a shared address book and quickly invite contacts to sessions. Request your admin to enable this feature.",
        "learn_more": "Learn more",
        "features_title": "Contacts management features",
        "feature_shared_title": "Shared Address Book",
        "feature_shared_desc": "Store And Access Customer Details Across Your Team",
        "feature_invites_title": "Quick Invites",
        "feature_invites_desc": "Select Contacts During Session Creation With Auto-Fill",
        "n_selected": "{n} selected",
        "one_selected": "{n} selected",
        "confirm_delete_contacts": "Are you sure you want to delete {n} contacts?",
        "confirm_delete_one_contact": "Are you sure you want to delete {n} contact?",
        "confirm_add_fav_contacts": "Are you sure you want to add {n} contacts to favorites?",
        "confirm_add_fav_one_contact": "Are you sure you want to add {n} contact to favorites?",
        "confirm_remove_fav_contacts": "Are you sure you want to remove {n} contacts from favorites?",
        "confirm_remove_fav_one_contact": "Are you sure you want to remove {n} contact from favorites?",
        "contacts_deleted": "{n} contacts deleted",
        "one_contact_deleted": "{n} contact deleted",
        "contacts_exported": "{n} contacts exported",
        "one_contact_exported": "{n} contact exported",
        "rows_not_imported": "{n} rows could not be imported",
        "one_row_not_imported": "{n} row could not be imported",
        "minutes_ago": "{n} mins ago",
        "hours_ago": "{n} hours ago",
        "one_hour_ago": "{n} hour ago",
        "days_ago": "{n} days ago",
        "one_day_ago": "{n} day ago",
        "weeks_ago": "{n} weeks ago",
        "one_week_ago": "{n} week ago"
    },
    "es_ES": {
        "contacts": "Contactos",
        "contacts_subtitle": "Administre la libreta de direcciones de su empresa",
        "import": "Importar",
        "export": "Exportar",
        "add_contact": "Agregar contacto",
        "import_contacts": "Importar contactos",
        "type_to_search": "Escriba para buscar",
        "all": "Todos",
        "name": "Nombre",
        "phone": "Teléfono",
        "email": "Correo electrónico",
        "company": "Empresa",
        "notes": "Notas",
        "today": "Hoy",
        "this_week": "Esta semana",
        "this_month": "Este mes",
        "this_year": "Este año",
        "filters": "Filtros",
        "filter_by": "Filtrar por",
        "reset_filters": "Restablecer filtros",
        "status": "Estado",
        "all_contacts": "Todos los contactos",
        "favorites_only": "Solo favoritos",
        "created": "Creado",
        "created_at": "Fecha de creación",
        "actions": "Acciones",
        "bulk_actions": "Acciones masivas",
        "add_to_favorites": "Agregar a favoritos",
        "remove_from_favorites": "Quitar de favoritos",
        "delete": "Eliminar",
        "delete_contact": "Eliminar contacto",
        "delete_contacts": "Eliminar contactos",
        "cancel": "Cancelar",
        "invite": "Invitar",
        "view_details": "Ver detalles",
        "edit_contact": "Editar contacto",
        "not_available": "N/D",
        "just_now": "Justo ahora",
        "no_contacts_yet": "Aún no hay contactos",
        "empty_desc_can_add": "Agregue su primer contacto o impórtelos desde un archivo CSV",
        "empty_desc_view_only": "Aún no se han agregado contactos",
        "favorites": "Favoritos",
        "show": "Mostrar",
        "rows": "filas",
        "no_favorites": "Sin favoritos",
        "no_favorites_yet": "Aún no hay contactos favoritos. Marque contactos como favoritos para acceder a ellos rápidamente.",
        "no_contacts_found": "No se encontraron contactos",
        "all_are_favorites": "Todos los contactos están marcados como favoritos.",
        "confirm_delete_named": "¿Está seguro de que desea eliminar el contacto {name}?",
        "confirm_add_fav_named": "¿Está seguro de que desea agregar a {name} a favoritos?",
        "confirm_remove_fav_named": "¿Está seguro de que desea quitar a {name} de favoritos?",
        "contact_deleted": "Contacto eliminado",
        "error_occurred": "Se produjo un error",
        "added_to_favorites": "Agregado a favoritos",
        "removed_from_favorites": "Quitado de favoritos",
        "export_failed": "Error al exportar",
        "contact_added": "Contacto agregado",
        "contact_updated": "Contacto actualizado",
        "contacts_imported": "Contactos importados",
        "required_field": "Campo obligatorio",
        "enter_name": "Ingrese el nombre",
        "enter_company": "Ingrese la empresa",
        "enter_phone": "Ingrese el teléfono",
        "enter_email": "Ingrese el correo electrónico",
        "notes_placeholder": "Agregue notas sobre este contacto...",
        "mark_as_favorite": "Marcar como favorito",
        "add_another_after_save": "Agregar otro contacto después de guardar",
        "save_changes": "Guardar cambios",
        "name_required": "El nombre es obligatorio",
        "name_min_length": "El nombre debe tener al menos 1 carácter",
        "max_chars": "Se permiten hasta {n} caracteres",
        "invalid_email": "Dirección de correo electrónico no válida",
        "invalid_phone": "Número de teléfono no válido",
        "phone_or_email_required": "Se requiere teléfono o correo electrónico",
        "contact_details": "Detalles del contacto",
        "label_copied": "Copiado: {label}",
        "close": "Cerrar",
        "change": "Cambiar",
        "select_from_contacts": "Seleccionar de contactos",
        "choose_contact_desc": "Elija un contacto de su libreta de direcciones",
        "select_contact_title": "Seleccionar contacto",
        "picker_search_email": "Buscar contactos o ingresar correo electrónico...",
        "picker_search_phone": "Buscar contactos o ingresar número de teléfono...",
        "loading_contacts": "Cargando contactos...",
        "no_contacts_found_for": "No se encontraron contactos para \"{value}\"",
        "no_contacts_available": "No hay contactos disponibles",
        "loading_more": "Cargando más...",
        "add_new_contact": "Agregar nuevo contacto",
        "continue": "Continuar",
        "invalid_file_type": "Tipo de archivo no válido. Cargue un archivo de Excel (.xlsx) o CSV (.csv).",
        "file_too_large": "El archivo es demasiado grande. El tamaño máximo es {n} MB.",
        "import_failed": "Error en la importación. Inténtelo de nuevo.",
        "total": "Total",
        "imported": "Importados",
        "failed": "Fallidos",
        "row": "Fila",
        "reason": "Motivo",
        "none_imported": "No se importó ningún contacto. Revise su archivo e inténtelo de nuevo.",
        "done": "Listo",
        "how_to_import": "Cómo importar contactos",
        "import_step_template": "Descargue nuestra plantilla CSV para garantizar el formato correcto",
        "import_step_required": "Campos obligatorios: Nombre completo, Número de teléfono o Correo electrónico",
        "import_step_phone": "Si se proporciona el número de teléfono, también se requieren el código de país y el código ISO del país",
        "import_step_optional": "Campos opcionales: Empresa, Notas",
        "import_step_max_size": "Tamaño máximo de archivo: {n} MB (aproximadamente 10.000 contactos)",
        "drop_title": "Arrastre y suelte su archivo CSV aquí",
        "drop_or": "o",
        "browse_files": "explorar archivos",
        "kb": "KB",
        "need_template": "¿Necesita una plantilla?",
        "download_template": "Descargar plantilla CSV",
        "feature_not_enabled_title": "La función de gestión de contactos no está habilitada",
        "feature_not_enabled_desc": "Guarde los datos de los clientes en una libreta de direcciones compartida e invite rápidamente a contactos a las sesiones. Solicite a su administrador que habilite esta función.",
        "learn_more": "Más información",
        "features_title": "Funciones de gestión de contactos",
        "feature_shared_title": "Libreta de direcciones compartida",
        "feature_shared_desc": "Guarde y consulte los datos de los clientes en todo su equipo",
        "feature_invites_title": "Invitaciones rápidas",
        "feature_invites_desc": "Seleccione contactos al crear una sesión con autocompletado",
        "n_selected": "{n} seleccionados",
        "one_selected": "{n} seleccionado",
        "confirm_delete_contacts": "¿Está seguro de que desea eliminar {n} contactos?",
        "confirm_delete_one_contact": "¿Está seguro de que desea eliminar {n} contacto?",
        "confirm_add_fav_contacts": "¿Está seguro de que desea agregar {n} contactos a favoritos?",
        "confirm_add_fav_one_contact": "¿Está seguro de que desea agregar {n} contacto a favoritos?",
        "confirm_remove_fav_contacts": "¿Está seguro de que desea quitar {n} contactos de favoritos?",
        "confirm_remove_fav_one_contact": "¿Está seguro de que desea quitar {n} contacto de favoritos?",
        "contacts_deleted": "{n} contactos eliminados",
        "one_contact_deleted": "{n} contacto eliminado",
        "contacts_exported": "{n} contactos exportados",
        "one_contact_exported": "{n} contacto exportado",
        "rows_not_imported": "{n} filas no se pudieron importar",
        "one_row_not_imported": "{n} fila no se pudo importar",
        "minutes_ago": "hace {n} min",
        "hours_ago": "hace {n} horas",
        "one_hour_ago": "hace {n} hora",
        "days_ago": "hace {n} días",
        "one_day_ago": "hace {n} día",
        "weeks_ago": "hace {n} semanas",
        "one_week_ago": "hace {n} semana"
    },
    "es_MX": {
        "contacts": "Contactos",
        "contacts_subtitle": "Administre la libreta de direcciones de su empresa",
        "import": "Importar",
        "export": "Exportar",
        "add_contact": "Agregar contacto",
        "import_contacts": "Importar contactos",
        "type_to_search": "Escriba para buscar",
        "all": "Todos",
        "name": "Nombre",
        "phone": "Teléfono",
        "email": "Correo electrónico",
        "company": "Empresa",
        "notes": "Notas",
        "today": "Hoy",
        "this_week": "Esta semana",
        "this_month": "Este mes",
        "this_year": "Este año",
        "filters": "Filtros",
        "filter_by": "Filtrar por",
        "reset_filters": "Restablecer filtros",
        "status": "Estado",
        "all_contacts": "Todos los contactos",
        "favorites_only": "Solo favoritos",
        "created": "Creado",
        "created_at": "Fecha de creación",
        "actions": "Acciones",
        "bulk_actions": "Acciones masivas",
        "add_to_favorites": "Agregar a favoritos",
        "remove_from_favorites": "Quitar de favoritos",
        "delete": "Eliminar",
        "delete_contact": "Eliminar contacto",
        "delete_contacts": "Eliminar contactos",
        "cancel": "Cancelar",
        "invite": "Invitar",
        "view_details": "Ver detalles",
        "edit_contact": "Editar contacto",
        "not_available": "N/D",
        "just_now": "Justo ahora",
        "no_contacts_yet": "Aún no hay contactos",
        "empty_desc_can_add": "Agregue su primer contacto o impórtelos desde un archivo CSV",
        "empty_desc_view_only": "Aún no se han agregado contactos",
        "favorites": "Favoritos",
        "show": "Mostrar",
        "rows": "filas",
        "no_favorites": "Sin favoritos",
        "no_favorites_yet": "Aún no hay contactos favoritos. Marque contactos como favoritos para acceder a ellos rápidamente.",
        "no_contacts_found": "No se encontraron contactos",
        "all_are_favorites": "Todos los contactos están marcados como favoritos.",
        "confirm_delete_named": "¿Está seguro de que desea eliminar el contacto {name}?",
        "confirm_add_fav_named": "¿Está seguro de que desea agregar a {name} a favoritos?",
        "confirm_remove_fav_named": "¿Está seguro de que desea quitar a {name} de favoritos?",
        "contact_deleted": "Contacto eliminado",
        "error_occurred": "Se produjo un error",
        "added_to_favorites": "Agregado a favoritos",
        "removed_from_favorites": "Quitado de favoritos",
        "export_failed": "Error al exportar",
        "contact_added": "Contacto agregado",
        "contact_updated": "Contacto actualizado",
        "contacts_imported": "Contactos importados",
        "required_field": "Campo obligatorio",
        "enter_name": "Ingrese el nombre",
        "enter_company": "Ingrese la empresa",
        "enter_phone": "Ingrese el teléfono",
        "enter_email": "Ingrese el correo electrónico",
        "notes_placeholder": "Agregue notas sobre este contacto...",
        "mark_as_favorite": "Marcar como favorito",
        "add_another_after_save": "Agregar otro contacto después de guardar",
        "save_changes": "Guardar cambios",
        "name_required": "El nombre es obligatorio",
        "name_min_length": "El nombre debe tener al menos 1 carácter",
        "max_chars": "Se permiten hasta {n} caracteres",
        "invalid_email": "Dirección de correo electrónico no válida",
        "invalid_phone": "Número de teléfono no válido",
        "phone_or_email_required": "Se requiere teléfono o correo electrónico",
        "contact_details": "Detalles del contacto",
        "label_copied": "Copiado: {label}",
        "close": "Cerrar",
        "change": "Cambiar",
        "select_from_contacts": "Seleccionar de contactos",
        "choose_contact_desc": "Elija un contacto de su libreta de direcciones",
        "select_contact_title": "Seleccionar contacto",
        "picker_search_email": "Buscar contactos o ingresar correo electrónico...",
        "picker_search_phone": "Buscar contactos o ingresar número de teléfono...",
        "loading_contacts": "Cargando contactos...",
        "no_contacts_found_for": "No se encontraron contactos para \"{value}\"",
        "no_contacts_available": "No hay contactos disponibles",
        "loading_more": "Cargando más...",
        "add_new_contact": "Agregar nuevo contacto",
        "continue": "Continuar",
        "invalid_file_type": "Tipo de archivo no válido. Cargue un archivo de Excel (.xlsx) o CSV (.csv).",
        "file_too_large": "El archivo es demasiado grande. El tamaño máximo es {n} MB.",
        "import_failed": "Error en la importación. Inténtelo de nuevo.",
        "total": "Total",
        "imported": "Importados",
        "failed": "Fallidos",
        "row": "Fila",
        "reason": "Motivo",
        "none_imported": "No se importó ningún contacto. Revise su archivo e inténtelo de nuevo.",
        "done": "Listo",
        "how_to_import": "Cómo importar contactos",
        "import_step_template": "Descargue nuestra plantilla CSV para garantizar el formato correcto",
        "import_step_required": "Campos obligatorios: Nombre completo, Número de teléfono o Correo electrónico",
        "import_step_phone": "Si se proporciona el número de teléfono, también se requieren el código de país y el código ISO del país",
        "import_step_optional": "Campos opcionales: Empresa, Notas",
        "import_step_max_size": "Tamaño máximo de archivo: {n} MB (aproximadamente 10.000 contactos)",
        "drop_title": "Arrastre y suelte su archivo CSV aquí",
        "drop_or": "o",
        "browse_files": "explorar archivos",
        "kb": "KB",
        "need_template": "¿Necesita una plantilla?",
        "download_template": "Descargar plantilla CSV",
        "feature_not_enabled_title": "La función de gestión de contactos no está habilitada",
        "feature_not_enabled_desc": "Guarde los datos de los clientes en una libreta de direcciones compartida e invite rápidamente a contactos a las sesiones. Solicite a su administrador que habilite esta función.",
        "learn_more": "Más información",
        "features_title": "Funciones de gestión de contactos",
        "feature_shared_title": "Libreta de direcciones compartida",
        "feature_shared_desc": "Guarde y consulte los datos de los clientes en todo su equipo",
        "feature_invites_title": "Invitaciones rápidas",
        "feature_invites_desc": "Seleccione contactos al crear una sesión con autocompletado",
        "n_selected": "{n} seleccionados",
        "one_selected": "{n} seleccionado",
        "confirm_delete_contacts": "¿Está seguro de que desea eliminar {n} contactos?",
        "confirm_delete_one_contact": "¿Está seguro de que desea eliminar {n} contacto?",
        "confirm_add_fav_contacts": "¿Está seguro de que desea agregar {n} contactos a favoritos?",
        "confirm_add_fav_one_contact": "¿Está seguro de que desea agregar {n} contacto a favoritos?",
        "confirm_remove_fav_contacts": "¿Está seguro de que desea quitar {n} contactos de favoritos?",
        "confirm_remove_fav_one_contact": "¿Está seguro de que desea quitar {n} contacto de favoritos?",
        "contacts_deleted": "{n} contactos eliminados",
        "one_contact_deleted": "{n} contacto eliminado",
        "contacts_exported": "{n} contactos exportados",
        "one_contact_exported": "{n} contacto exportado",
        "rows_not_imported": "{n} filas no se pudieron importar",
        "one_row_not_imported": "{n} fila no se pudo importar",
        "minutes_ago": "hace {n} min",
        "hours_ago": "hace {n} horas",
        "one_hour_ago": "hace {n} hora",
        "days_ago": "hace {n} días",
        "one_day_ago": "hace {n} día",
        "weeks_ago": "hace {n} semanas",
        "one_week_ago": "hace {n} semana"
    },
    "es_AR": {
        "contacts": "Contactos",
        "contacts_subtitle": "Administre la libreta de direcciones de su empresa",
        "import": "Importar",
        "export": "Exportar",
        "add_contact": "Agregar contacto",
        "import_contacts": "Importar contactos",
        "type_to_search": "Escriba para buscar",
        "all": "Todos",
        "name": "Nombre",
        "phone": "Teléfono",
        "email": "Correo electrónico",
        "company": "Empresa",
        "notes": "Notas",
        "today": "Hoy",
        "this_week": "Esta semana",
        "this_month": "Este mes",
        "this_year": "Este año",
        "filters": "Filtros",
        "filter_by": "Filtrar por",
        "reset_filters": "Restablecer filtros",
        "status": "Estado",
        "all_contacts": "Todos los contactos",
        "favorites_only": "Solo favoritos",
        "created": "Creado",
        "created_at": "Fecha de creación",
        "actions": "Acciones",
        "bulk_actions": "Acciones masivas",
        "add_to_favorites": "Agregar a favoritos",
        "remove_from_favorites": "Quitar de favoritos",
        "delete": "Eliminar",
        "delete_contact": "Eliminar contacto",
        "delete_contacts": "Eliminar contactos",
        "cancel": "Cancelar",
        "invite": "Invitar",
        "view_details": "Ver detalles",
        "edit_contact": "Editar contacto",
        "not_available": "N/D",
        "just_now": "Justo ahora",
        "no_contacts_yet": "Aún no hay contactos",
        "empty_desc_can_add": "Agregue su primer contacto o impórtelos desde un archivo CSV",
        "empty_desc_view_only": "Aún no se han agregado contactos",
        "favorites": "Favoritos",
        "show": "Mostrar",
        "rows": "filas",
        "no_favorites": "Sin favoritos",
        "no_favorites_yet": "Aún no hay contactos favoritos. Marque contactos como favoritos para acceder a ellos rápidamente.",
        "no_contacts_found": "No se encontraron contactos",
        "all_are_favorites": "Todos los contactos están marcados como favoritos.",
        "confirm_delete_named": "¿Está seguro de que desea eliminar el contacto {name}?",
        "confirm_add_fav_named": "¿Está seguro de que desea agregar a {name} a favoritos?",
        "confirm_remove_fav_named": "¿Está seguro de que desea quitar a {name} de favoritos?",
        "contact_deleted": "Contacto eliminado",
        "error_occurred": "Se produjo un error",
        "added_to_favorites": "Agregado a favoritos",
        "removed_from_favorites": "Quitado de favoritos",
        "export_failed": "Error al exportar",
        "contact_added": "Contacto agregado",
        "contact_updated": "Contacto actualizado",
        "contacts_imported": "Contactos importados",
        "required_field": "Campo obligatorio",
        "enter_name": "Ingrese el nombre",
        "enter_company": "Ingrese la empresa",
        "enter_phone": "Ingrese el teléfono",
        "enter_email": "Ingrese el correo electrónico",
        "notes_placeholder": "Agregue notas sobre este contacto...",
        "mark_as_favorite": "Marcar como favorito",
        "add_another_after_save": "Agregar otro contacto después de guardar",
        "save_changes": "Guardar cambios",
        "name_required": "El nombre es obligatorio",
        "name_min_length": "El nombre debe tener al menos 1 carácter",
        "max_chars": "Se permiten hasta {n} caracteres",
        "invalid_email": "Dirección de correo electrónico no válida",
        "invalid_phone": "Número de teléfono no válido",
        "phone_or_email_required": "Se requiere teléfono o correo electrónico",
        "contact_details": "Detalles del contacto",
        "label_copied": "Copiado: {label}",
        "close": "Cerrar",
        "change": "Cambiar",
        "select_from_contacts": "Seleccionar de contactos",
        "choose_contact_desc": "Elija un contacto de su libreta de direcciones",
        "select_contact_title": "Seleccionar contacto",
        "picker_search_email": "Buscar contactos o ingresar correo electrónico...",
        "picker_search_phone": "Buscar contactos o ingresar número de teléfono...",
        "loading_contacts": "Cargando contactos...",
        "no_contacts_found_for": "No se encontraron contactos para \"{value}\"",
        "no_contacts_available": "No hay contactos disponibles",
        "loading_more": "Cargando más...",
        "add_new_contact": "Agregar nuevo contacto",
        "continue": "Continuar",
        "invalid_file_type": "Tipo de archivo no válido. Cargue un archivo de Excel (.xlsx) o CSV (.csv).",
        "file_too_large": "El archivo es demasiado grande. El tamaño máximo es {n} MB.",
        "import_failed": "Error en la importación. Inténtelo de nuevo.",
        "total": "Total",
        "imported": "Importados",
        "failed": "Fallidos",
        "row": "Fila",
        "reason": "Motivo",
        "none_imported": "No se importó ningún contacto. Revise su archivo e inténtelo de nuevo.",
        "done": "Listo",
        "how_to_import": "Cómo importar contactos",
        "import_step_template": "Descargue nuestra plantilla CSV para garantizar el formato correcto",
        "import_step_required": "Campos obligatorios: Nombre completo, Número de teléfono o Correo electrónico",
        "import_step_phone": "Si se proporciona el número de teléfono, también se requieren el código de país y el código ISO del país",
        "import_step_optional": "Campos opcionales: Empresa, Notas",
        "import_step_max_size": "Tamaño máximo de archivo: {n} MB (aproximadamente 10.000 contactos)",
        "drop_title": "Arrastre y suelte su archivo CSV aquí",
        "drop_or": "o",
        "browse_files": "explorar archivos",
        "kb": "KB",
        "need_template": "¿Necesita una plantilla?",
        "download_template": "Descargar plantilla CSV",
        "feature_not_enabled_title": "La función de gestión de contactos no está habilitada",
        "feature_not_enabled_desc": "Guarde los datos de los clientes en una libreta de direcciones compartida e invite rápidamente a contactos a las sesiones. Solicite a su administrador que habilite esta función.",
        "learn_more": "Más información",
        "features_title": "Funciones de gestión de contactos",
        "feature_shared_title": "Libreta de direcciones compartida",
        "feature_shared_desc": "Guarde y consulte los datos de los clientes en todo su equipo",
        "feature_invites_title": "Invitaciones rápidas",
        "feature_invites_desc": "Seleccione contactos al crear una sesión con autocompletado",
        "n_selected": "{n} seleccionados",
        "one_selected": "{n} seleccionado",
        "confirm_delete_contacts": "¿Está seguro de que desea eliminar {n} contactos?",
        "confirm_delete_one_contact": "¿Está seguro de que desea eliminar {n} contacto?",
        "confirm_add_fav_contacts": "¿Está seguro de que desea agregar {n} contactos a favoritos?",
        "confirm_add_fav_one_contact": "¿Está seguro de que desea agregar {n} contacto a favoritos?",
        "confirm_remove_fav_contacts": "¿Está seguro de que desea quitar {n} contactos de favoritos?",
        "confirm_remove_fav_one_contact": "¿Está seguro de que desea quitar {n} contacto de favoritos?",
        "contacts_deleted": "{n} contactos eliminados",
        "one_contact_deleted": "{n} contacto eliminado",
        "contacts_exported": "{n} contactos exportados",
        "one_contact_exported": "{n} contacto exportado",
        "rows_not_imported": "{n} filas no se pudieron importar",
        "one_row_not_imported": "{n} fila no se pudo importar",
        "minutes_ago": "hace {n} min",
        "hours_ago": "hace {n} horas",
        "one_hour_ago": "hace {n} hora",
        "days_ago": "hace {n} días",
        "one_day_ago": "hace {n} día",
        "weeks_ago": "hace {n} semanas",
        "one_week_ago": "hace {n} semana"
    },
    "fr_FR": {
        "contacts": "Contacts",
        "contacts_subtitle": "Gérez le carnet d'adresses de votre entreprise",
        "import": "Importer",
        "export": "Exporter",
        "add_contact": "Ajouter un contact",
        "import_contacts": "Importer des contacts",
        "type_to_search": "Saisissez pour rechercher",
        "all": "Tous",
        "name": "Nom",
        "phone": "Téléphone",
        "email": "E-mail",
        "company": "Entreprise",
        "notes": "Notes",
        "today": "Aujourd'hui",
        "this_week": "Cette semaine",
        "this_month": "Ce mois-ci",
        "this_year": "Cette année",
        "filters": "Filtres",
        "filter_by": "Filtrer par",
        "reset_filters": "Réinitialiser les filtres",
        "status": "Statut",
        "all_contacts": "Tous les contacts",
        "favorites_only": "Favoris uniquement",
        "created": "Créé",
        "created_at": "Date de création",
        "actions": "Actions",
        "bulk_actions": "Actions groupées",
        "add_to_favorites": "Ajouter aux favoris",
        "remove_from_favorites": "Retirer des favoris",
        "delete": "Supprimer",
        "delete_contact": "Supprimer le contact",
        "delete_contacts": "Supprimer les contacts",
        "cancel": "Annuler",
        "invite": "Inviter",
        "view_details": "Voir les détails",
        "edit_contact": "Modifier le contact",
        "not_available": "N/D",
        "just_now": "À l'instant",
        "no_contacts_yet": "Aucun contact pour le moment",
        "empty_desc_can_add": "Ajoutez votre premier contact ou importez un fichier CSV",
        "empty_desc_view_only": "Aucun contact n'a encore été ajouté",
        "favorites": "Favoris",
        "show": "Afficher",
        "rows": "lignes",
        "no_favorites": "Aucun favori",
        "no_favorites_yet": "Aucun contact favori pour le moment. Marquez des contacts comme favoris pour y accéder rapidement.",
        "no_contacts_found": "Aucun contact trouvé",
        "all_are_favorites": "Tous les contacts sont marqués comme favoris.",
        "confirm_delete_named": "Voulez-vous vraiment supprimer le contact {name} ?",
        "confirm_add_fav_named": "Voulez-vous vraiment ajouter {name} aux favoris ?",
        "confirm_remove_fav_named": "Voulez-vous vraiment retirer {name} des favoris ?",
        "contact_deleted": "Contact supprimé",
        "error_occurred": "Une erreur s'est produite",
        "added_to_favorites": "Ajouté aux favoris",
        "removed_from_favorites": "Retiré des favoris",
        "export_failed": "Échec de l'exportation",
        "contact_added": "Contact ajouté",
        "contact_updated": "Contact mis à jour",
        "contacts_imported": "Contacts importés",
        "required_field": "Champ obligatoire",
        "enter_name": "Saisissez le nom",
        "enter_company": "Saisissez l'entreprise",
        "enter_phone": "Saisissez le téléphone",
        "enter_email": "Saisissez l'e-mail",
        "notes_placeholder": "Ajoutez des notes sur ce contact...",
        "mark_as_favorite": "Marquer comme favori",
        "add_another_after_save": "Ajouter un autre contact après l'enregistrement",
        "save_changes": "Enregistrer les modifications",
        "name_required": "Le nom est obligatoire",
        "name_min_length": "Le nom doit comporter au moins 1 caractère",
        "max_chars": "Jusqu'à {n} caractères autorisés",
        "invalid_email": "Adresse e-mail non valide",
        "invalid_phone": "Numéro de téléphone non valide",
        "phone_or_email_required": "Le téléphone ou l'e-mail est obligatoire",
        "contact_details": "Détails du contact",
        "label_copied": "Copié : {label}",
        "close": "Fermer",
        "change": "Modifier",
        "select_from_contacts": "Sélectionner dans les contacts",
        "choose_contact_desc": "Choisissez un contact dans votre carnet d'adresses",
        "select_contact_title": "Sélectionner un contact",
        "picker_search_email": "Rechercher des contacts ou saisir un e-mail...",
        "picker_search_phone": "Rechercher des contacts ou saisir un numéro de téléphone...",
        "loading_contacts": "Chargement des contacts...",
        "no_contacts_found_for": "Aucun contact trouvé pour « {value} »",
        "no_contacts_available": "Aucun contact disponible",
        "loading_more": "Chargement de la suite...",
        "add_new_contact": "Ajouter un nouveau contact",
        "continue": "Continuer",
        "invalid_file_type": "Type de fichier non valide. Veuillez importer un fichier Excel (.xlsx) ou CSV (.csv).",
        "file_too_large": "Le fichier est trop volumineux. La taille maximale est de {n} Mo.",
        "import_failed": "Échec de l'importation. Veuillez réessayer.",
        "total": "Total",
        "imported": "Importés",
        "failed": "Échecs",
        "row": "Ligne",
        "reason": "Motif",
        "none_imported": "Aucun contact n'a été importé. Veuillez vérifier votre fichier et réessayer.",
        "done": "Terminé",
        "how_to_import": "Comment importer des contacts",
        "import_step_template": "Téléchargez notre modèle CSV pour garantir un format correct",
        "import_step_required": "Champs obligatoires : nom complet, numéro de téléphone ou e-mail",
        "import_step_phone": "Si un numéro de téléphone est fourni, l'indicatif du pays et le code ISO du pays sont également obligatoires",
        "import_step_optional": "Champs facultatifs : entreprise, notes",
        "import_step_max_size": "Taille maximale du fichier : {n} Mo (environ 10 000 contacts)",
        "drop_title": "Glissez-déposez votre fichier CSV ici",
        "drop_or": "ou",
        "browse_files": "parcourir les fichiers",
        "kb": "Ko",
        "need_template": "Besoin d'un modèle ?",
        "download_template": "Télécharger le modèle CSV",
        "feature_not_enabled_title": "La fonctionnalité de gestion des contacts n'est pas activée",
        "feature_not_enabled_desc": "Stockez les coordonnées des clients dans un carnet d'adresses partagé et invitez rapidement des contacts aux sessions. Demandez à votre administrateur d'activer cette fonctionnalité.",
        "learn_more": "En savoir plus",
        "features_title": "Fonctionnalités de gestion des contacts",
        "feature_shared_title": "Carnet d'adresses partagé",
        "feature_shared_desc": "Stockez et consultez les coordonnées des clients dans toute votre équipe",
        "feature_invites_title": "Invitations rapides",
        "feature_invites_desc": "Sélectionnez des contacts lors de la création d'une session grâce au remplissage automatique",
        "n_selected": "{n} sélectionnés",
        "one_selected": "{n} sélectionné",
        "confirm_delete_contacts": "Voulez-vous vraiment supprimer {n} contacts ?",
        "confirm_delete_one_contact": "Voulez-vous vraiment supprimer {n} contact ?",
        "confirm_add_fav_contacts": "Voulez-vous vraiment ajouter {n} contacts aux favoris ?",
        "confirm_add_fav_one_contact": "Voulez-vous vraiment ajouter {n} contact aux favoris ?",
        "confirm_remove_fav_contacts": "Voulez-vous vraiment retirer {n} contacts des favoris ?",
        "confirm_remove_fav_one_contact": "Voulez-vous vraiment retirer {n} contact des favoris ?",
        "contacts_deleted": "{n} contacts supprimés",
        "one_contact_deleted": "{n} contact supprimé",
        "contacts_exported": "{n} contacts exportés",
        "one_contact_exported": "{n} contact exporté",
        "rows_not_imported": "{n} lignes n'ont pas pu être importées",
        "one_row_not_imported": "{n} ligne n'a pas pu être importée",
        "minutes_ago": "il y a {n} min",
        "hours_ago": "il y a {n} heures",
        "one_hour_ago": "il y a {n} heure",
        "days_ago": "il y a {n} jours",
        "one_day_ago": "il y a {n} jour",
        "weeks_ago": "il y a {n} semaines",
        "one_week_ago": "il y a {n} semaine"
    },
    "en_CA": {
        "contacts": "Contacts",
        "contacts_subtitle": "Manage your company address book",
        "import": "Import",
        "export": "Export",
        "add_contact": "Add Contact",
        "import_contacts": "Import Contacts",
        "type_to_search": "Type to search",
        "all": "All",
        "name": "Name",
        "phone": "Phone",
        "email": "Email",
        "company": "Company",
        "notes": "Notes",
        "today": "Today",
        "this_week": "This Week",
        "this_month": "This Month",
        "this_year": "This Year",
        "filters": "Filters",
        "filter_by": "Filter by",
        "reset_filters": "Reset filters",
        "status": "Status",
        "all_contacts": "All Contacts",
        "favorites_only": "Favorites Only",
        "created": "Created",
        "created_at": "Created At",
        "actions": "Actions",
        "bulk_actions": "Bulk Actions",
        "add_to_favorites": "Add to Favorites",
        "remove_from_favorites": "Remove from Favorites",
        "delete": "Delete",
        "delete_contact": "Delete Contact",
        "delete_contacts": "Delete Contacts",
        "cancel": "Cancel",
        "invite": "Invite",
        "view_details": "View Details",
        "edit_contact": "Edit Contact",
        "not_available": "N/A",
        "just_now": "Just now",
        "no_contacts_yet": "No contacts yet",
        "empty_desc_can_add": "Add your first contact or import from a CSV file",
        "empty_desc_view_only": "No contacts have been added yet",
        "favorites": "Favorites",
        "show": "Show",
        "rows": "rows",
        "no_favorites": "No favorites",
        "no_favorites_yet": "No favorite contacts yet. Mark contacts as favorites for quick access.",
        "no_contacts_found": "No contacts found",
        "all_are_favorites": "All contacts are marked as favorites.",
        "confirm_delete_named": "Are you sure you want to delete {name} contact?",
        "confirm_add_fav_named": "Are you sure you want to add {name} to favorites?",
        "confirm_remove_fav_named": "Are you sure you want to remove {name} from favorites?",
        "contact_deleted": "Contact deleted",
        "error_occurred": "An error occurred",
        "added_to_favorites": "Added to favorites",
        "removed_from_favorites": "Removed from favorites",
        "export_failed": "Export failed",
        "contact_added": "Contact added",
        "contact_updated": "Contact updated",
        "contacts_imported": "Contacts imported",
        "required_field": "Required field",
        "enter_name": "Enter name",
        "enter_company": "Enter company",
        "enter_phone": "Enter phone",
        "enter_email": "Enter email",
        "notes_placeholder": "Add notes about this contact...",
        "mark_as_favorite": "Mark as Favorite",
        "add_another_after_save": "Add another contact after saving",
        "save_changes": "Save Changes",
        "name_required": "Name is required",
        "name_min_length": "Name must be at least 1 character",
        "max_chars": "Up to {n} characters allowed",
        "invalid_email": "Invalid email address",
        "invalid_phone": "Invalid phone number",
        "phone_or_email_required": "Phone or Email is required",
        "contact_details": "Contact Details",
        "label_copied": "{label} copied",
        "close": "Close",
        "change": "Change",
        "select_from_contacts": "Select from Contacts",
        "choose_contact_desc": "Choose a contact from your address book",
        "select_contact_title": "Select Contact",
        "picker_search_email": "Search contacts or enter email...",
        "picker_search_phone": "Search contacts or enter phone number...",
        "loading_contacts": "Loading contacts...",
        "no_contacts_found_for": "No contacts found for \"{value}\"",
        "no_contacts_available": "No contacts available",
        "loading_more": "Loading more...",
        "add_new_contact": "Add New Contact",
        "continue": "Continue",
        "invalid_file_type": "Invalid file type. Please upload an Excel (.xlsx) or CSV (.csv) file.",
        "file_too_large": "File is too large. Maximum size is {n}MB.",
        "import_failed": "Import failed. Please try again.",
        "total": "Total",
        "imported": "Imported",
        "failed": "Failed",
        "row": "Row",
        "reason": "Reason",
        "none_imported": "No contacts were imported. Please check your file and try again.",
        "done": "Done",
        "how_to_import": "How to import contacts",
        "import_step_template": "Download our CSV template to ensure proper formatting",
        "import_step_required": "Required fields: Full Name, Phone Number or Email",
        "import_step_phone": "If Phone Number is provided: Country Code and Country Iso are also required",
        "import_step_optional": "Optional fields: Company, Notes",
        "import_step_max_size": "Maximum file size: {n}MB (approximately 10,000 contacts)",
        "drop_title": "Drag and drop your CSV file here",
        "drop_or": "or",
        "browse_files": "browse files",
        "kb": "KB",
        "need_template": "Need a template?",
        "download_template": "Download CSV Template",
        "feature_not_enabled_title": "Contacts Management feature is not enabled",
        "feature_not_enabled_desc": "Store customer details in a shared address book and quickly invite contacts to sessions. Request your admin to enable this feature.",
        "learn_more": "Learn more",
        "features_title": "Contacts management features",
        "feature_shared_title": "Shared Address Book",
        "feature_shared_desc": "Store And Access Customer Details Across Your Team",
        "feature_invites_title": "Quick Invites",
        "feature_invites_desc": "Select Contacts During Session Creation With Auto-Fill",
        "n_selected": "{n} selected",
        "one_selected": "{n} selected",
        "confirm_delete_contacts": "Are you sure you want to delete {n} contacts?",
        "confirm_delete_one_contact": "Are you sure you want to delete {n} contact?",
        "confirm_add_fav_contacts": "Are you sure you want to add {n} contacts to favorites?",
        "confirm_add_fav_one_contact": "Are you sure you want to add {n} contact to favorites?",
        "confirm_remove_fav_contacts": "Are you sure you want to remove {n} contacts from favorites?",
        "confirm_remove_fav_one_contact": "Are you sure you want to remove {n} contact from favorites?",
        "contacts_deleted": "{n} contacts deleted",
        "one_contact_deleted": "{n} contact deleted",
        "contacts_exported": "{n} contacts exported",
        "one_contact_exported": "{n} contact exported",
        "rows_not_imported": "{n} rows could not be imported",
        "one_row_not_imported": "{n} row could not be imported",
        "minutes_ago": "{n} mins ago",
        "hours_ago": "{n} hours ago",
        "one_hour_ago": "{n} hour ago",
        "days_ago": "{n} days ago",
        "one_day_ago": "{n} day ago",
        "weeks_ago": "{n} weeks ago",
        "one_week_ago": "{n} week ago"
    },
    "fr_CA": {
        "contacts": "Contacts",
        "contacts_subtitle": "Gérez le carnet d'adresses de votre entreprise",
        "import": "Importer",
        "export": "Exporter",
        "add_contact": "Ajouter un contact",
        "import_contacts": "Importer des contacts",
        "type_to_search": "Saisissez pour rechercher",
        "all": "Tous",
        "name": "Nom",
        "phone": "Téléphone",
        "email": "E-mail",
        "company": "Entreprise",
        "notes": "Notes",
        "today": "Aujourd'hui",
        "this_week": "Cette semaine",
        "this_month": "Ce mois-ci",
        "this_year": "Cette année",
        "filters": "Filtres",
        "filter_by": "Filtrer par",
        "reset_filters": "Réinitialiser les filtres",
        "status": "Statut",
        "all_contacts": "Tous les contacts",
        "favorites_only": "Favoris uniquement",
        "created": "Créé",
        "created_at": "Date de création",
        "actions": "Actions",
        "bulk_actions": "Actions groupées",
        "add_to_favorites": "Ajouter aux favoris",
        "remove_from_favorites": "Retirer des favoris",
        "delete": "Supprimer",
        "delete_contact": "Supprimer le contact",
        "delete_contacts": "Supprimer les contacts",
        "cancel": "Annuler",
        "invite": "Inviter",
        "view_details": "Voir les détails",
        "edit_contact": "Modifier le contact",
        "not_available": "N/D",
        "just_now": "À l'instant",
        "no_contacts_yet": "Aucun contact pour le moment",
        "empty_desc_can_add": "Ajoutez votre premier contact ou importez un fichier CSV",
        "empty_desc_view_only": "Aucun contact n'a encore été ajouté",
        "favorites": "Favoris",
        "show": "Afficher",
        "rows": "lignes",
        "no_favorites": "Aucun favori",
        "no_favorites_yet": "Aucun contact favori pour le moment. Marquez des contacts comme favoris pour y accéder rapidement.",
        "no_contacts_found": "Aucun contact trouvé",
        "all_are_favorites": "Tous les contacts sont marqués comme favoris.",
        "confirm_delete_named": "Voulez-vous vraiment supprimer le contact {name} ?",
        "confirm_add_fav_named": "Voulez-vous vraiment ajouter {name} aux favoris ?",
        "confirm_remove_fav_named": "Voulez-vous vraiment retirer {name} des favoris ?",
        "contact_deleted": "Contact supprimé",
        "error_occurred": "Une erreur s'est produite",
        "added_to_favorites": "Ajouté aux favoris",
        "removed_from_favorites": "Retiré des favoris",
        "export_failed": "Échec de l'exportation",
        "contact_added": "Contact ajouté",
        "contact_updated": "Contact mis à jour",
        "contacts_imported": "Contacts importés",
        "required_field": "Champ obligatoire",
        "enter_name": "Saisissez le nom",
        "enter_company": "Saisissez l'entreprise",
        "enter_phone": "Saisissez le téléphone",
        "enter_email": "Saisissez l'e-mail",
        "notes_placeholder": "Ajoutez des notes sur ce contact...",
        "mark_as_favorite": "Marquer comme favori",
        "add_another_after_save": "Ajouter un autre contact après l'enregistrement",
        "save_changes": "Enregistrer les modifications",
        "name_required": "Le nom est obligatoire",
        "name_min_length": "Le nom doit comporter au moins 1 caractère",
        "max_chars": "Jusqu'à {n} caractères autorisés",
        "invalid_email": "Adresse e-mail non valide",
        "invalid_phone": "Numéro de téléphone non valide",
        "phone_or_email_required": "Le téléphone ou l'e-mail est obligatoire",
        "contact_details": "Détails du contact",
        "label_copied": "Copié : {label}",
        "close": "Fermer",
        "change": "Modifier",
        "select_from_contacts": "Sélectionner dans les contacts",
        "choose_contact_desc": "Choisissez un contact dans votre carnet d'adresses",
        "select_contact_title": "Sélectionner un contact",
        "picker_search_email": "Rechercher des contacts ou saisir un e-mail...",
        "picker_search_phone": "Rechercher des contacts ou saisir un numéro de téléphone...",
        "loading_contacts": "Chargement des contacts...",
        "no_contacts_found_for": "Aucun contact trouvé pour « {value} »",
        "no_contacts_available": "Aucun contact disponible",
        "loading_more": "Chargement de la suite...",
        "add_new_contact": "Ajouter un nouveau contact",
        "continue": "Continuer",
        "invalid_file_type": "Type de fichier non valide. Veuillez importer un fichier Excel (.xlsx) ou CSV (.csv).",
        "file_too_large": "Le fichier est trop volumineux. La taille maximale est de {n} Mo.",
        "import_failed": "Échec de l'importation. Veuillez réessayer.",
        "total": "Total",
        "imported": "Importés",
        "failed": "Échecs",
        "row": "Ligne",
        "reason": "Motif",
        "none_imported": "Aucun contact n'a été importé. Veuillez vérifier votre fichier et réessayer.",
        "done": "Terminé",
        "how_to_import": "Comment importer des contacts",
        "import_step_template": "Téléchargez notre modèle CSV pour garantir un format correct",
        "import_step_required": "Champs obligatoires : nom complet, numéro de téléphone ou e-mail",
        "import_step_phone": "Si un numéro de téléphone est fourni, l'indicatif du pays et le code ISO du pays sont également obligatoires",
        "import_step_optional": "Champs facultatifs : entreprise, notes",
        "import_step_max_size": "Taille maximale du fichier : {n} Mo (environ 10 000 contacts)",
        "drop_title": "Glissez-déposez votre fichier CSV ici",
        "drop_or": "ou",
        "browse_files": "parcourir les fichiers",
        "kb": "Ko",
        "need_template": "Besoin d'un modèle ?",
        "download_template": "Télécharger le modèle CSV",
        "feature_not_enabled_title": "La fonctionnalité de gestion des contacts n'est pas activée",
        "feature_not_enabled_desc": "Stockez les coordonnées des clients dans un carnet d'adresses partagé et invitez rapidement des contacts aux sessions. Demandez à votre administrateur d'activer cette fonctionnalité.",
        "learn_more": "En savoir plus",
        "features_title": "Fonctionnalités de gestion des contacts",
        "feature_shared_title": "Carnet d'adresses partagé",
        "feature_shared_desc": "Stockez et consultez les coordonnées des clients dans toute votre équipe",
        "feature_invites_title": "Invitations rapides",
        "feature_invites_desc": "Sélectionnez des contacts lors de la création d'une session grâce au remplissage automatique",
        "n_selected": "{n} sélectionnés",
        "one_selected": "{n} sélectionné",
        "confirm_delete_contacts": "Voulez-vous vraiment supprimer {n} contacts ?",
        "confirm_delete_one_contact": "Voulez-vous vraiment supprimer {n} contact ?",
        "confirm_add_fav_contacts": "Voulez-vous vraiment ajouter {n} contacts aux favoris ?",
        "confirm_add_fav_one_contact": "Voulez-vous vraiment ajouter {n} contact aux favoris ?",
        "confirm_remove_fav_contacts": "Voulez-vous vraiment retirer {n} contacts des favoris ?",
        "confirm_remove_fav_one_contact": "Voulez-vous vraiment retirer {n} contact des favoris ?",
        "contacts_deleted": "{n} contacts supprimés",
        "one_contact_deleted": "{n} contact supprimé",
        "contacts_exported": "{n} contacts exportés",
        "one_contact_exported": "{n} contact exporté",
        "rows_not_imported": "{n} lignes n'ont pas pu être importées",
        "one_row_not_imported": "{n} ligne n'a pas pu être importée",
        "minutes_ago": "il y a {n} min",
        "hours_ago": "il y a {n} heures",
        "one_hour_ago": "il y a {n} heure",
        "days_ago": "il y a {n} jours",
        "one_day_ago": "il y a {n} jour",
        "weeks_ago": "il y a {n} semaines",
        "one_week_ago": "il y a {n} semaine"
    },
    "pt_BR": {
        "contacts": "Contatos",
        "contacts_subtitle": "Gerencie o catálogo de endereços da sua empresa",
        "import": "Importar",
        "export": "Exportar",
        "add_contact": "Adicionar contato",
        "import_contacts": "Importar contatos",
        "type_to_search": "Digite para pesquisar",
        "all": "Todos",
        "name": "Nome",
        "phone": "Telefone",
        "email": "E-mail",
        "company": "Empresa",
        "notes": "Observações",
        "today": "Hoje",
        "this_week": "Esta semana",
        "this_month": "Este mês",
        "this_year": "Este ano",
        "filters": "Filtros",
        "filter_by": "Filtrar por",
        "reset_filters": "Redefinir filtros",
        "status": "Status",
        "all_contacts": "Todos os contatos",
        "favorites_only": "Somente favoritos",
        "created": "Criado",
        "created_at": "Criado em",
        "actions": "Ações",
        "bulk_actions": "Ações em massa",
        "add_to_favorites": "Adicionar aos favoritos",
        "remove_from_favorites": "Remover dos favoritos",
        "delete": "Excluir",
        "delete_contact": "Excluir contato",
        "delete_contacts": "Excluir contatos",
        "cancel": "Cancelar",
        "invite": "Convidar",
        "view_details": "Ver detalhes",
        "edit_contact": "Editar contato",
        "not_available": "N/D",
        "just_now": "Agora mesmo",
        "no_contacts_yet": "Nenhum contato ainda",
        "empty_desc_can_add": "Adicione seu primeiro contato ou importe de um arquivo CSV",
        "empty_desc_view_only": "Nenhum contato foi adicionado ainda",
        "favorites": "Favoritos",
        "show": "Mostrar",
        "rows": "linhas",
        "no_favorites": "Nenhum favorito",
        "no_favorites_yet": "Nenhum contato favorito ainda. Marque contatos como favoritos para acesso rápido.",
        "no_contacts_found": "Nenhum contato encontrado",
        "all_are_favorites": "Todos os contatos estão marcados como favoritos.",
        "confirm_delete_named": "Tem certeza de que deseja excluir o contato {name}?",
        "confirm_add_fav_named": "Tem certeza de que deseja adicionar {name} aos favoritos?",
        "confirm_remove_fav_named": "Tem certeza de que deseja remover {name} dos favoritos?",
        "contact_deleted": "Contato excluído",
        "error_occurred": "Ocorreu um erro",
        "added_to_favorites": "Adicionado aos favoritos",
        "removed_from_favorites": "Removido dos favoritos",
        "export_failed": "Falha na exportação",
        "contact_added": "Contato adicionado",
        "contact_updated": "Contato atualizado",
        "contacts_imported": "Contatos importados",
        "required_field": "Campo obrigatório",
        "enter_name": "Digite o nome",
        "enter_company": "Digite a empresa",
        "enter_phone": "Digite o telefone",
        "enter_email": "Digite o e-mail",
        "notes_placeholder": "Adicione observações sobre este contato...",
        "mark_as_favorite": "Marcar como favorito",
        "add_another_after_save": "Adicionar outro contato após salvar",
        "save_changes": "Salvar alterações",
        "name_required": "O nome é obrigatório",
        "name_min_length": "O nome deve ter pelo menos 1 caractere",
        "max_chars": "Até {n} caracteres permitidos",
        "invalid_email": "Endereço de e-mail inválido",
        "invalid_phone": "Número de telefone inválido",
        "phone_or_email_required": "Telefone ou e-mail é obrigatório",
        "contact_details": "Detalhes do contato",
        "label_copied": "Copiado: {label}",
        "close": "Fechar",
        "change": "Alterar",
        "select_from_contacts": "Selecionar dos contatos",
        "choose_contact_desc": "Escolha um contato do seu catálogo de endereços",
        "select_contact_title": "Selecionar contato",
        "picker_search_email": "Pesquise contatos ou digite o e-mail...",
        "picker_search_phone": "Pesquise contatos ou digite o número de telefone...",
        "loading_contacts": "Carregando contatos...",
        "no_contacts_found_for": "Nenhum contato encontrado para \"{value}\"",
        "no_contacts_available": "Nenhum contato disponível",
        "loading_more": "Carregando mais...",
        "add_new_contact": "Adicionar novo contato",
        "continue": "Continuar",
        "invalid_file_type": "Tipo de arquivo inválido. Envie um arquivo Excel (.xlsx) ou CSV (.csv).",
        "file_too_large": "O arquivo é muito grande. O tamanho máximo é {n} MB.",
        "import_failed": "Falha na importação. Tente novamente.",
        "total": "Total",
        "imported": "Importados",
        "failed": "Com falha",
        "row": "Linha",
        "reason": "Motivo",
        "none_imported": "Nenhum contato foi importado. Verifique seu arquivo e tente novamente.",
        "done": "Concluído",
        "how_to_import": "Como importar contatos",
        "import_step_template": "Baixe nosso modelo CSV para garantir a formatação correta",
        "import_step_required": "Campos obrigatórios: Nome completo, Número de telefone ou E-mail",
        "import_step_phone": "Se o número de telefone for informado, o código do país e o código ISO do país também são obrigatórios",
        "import_step_optional": "Campos opcionais: Empresa, Observações",
        "import_step_max_size": "Tamanho máximo do arquivo: {n} MB (aproximadamente 10.000 contatos)",
        "drop_title": "Arraste e solte seu arquivo CSV aqui",
        "drop_or": "ou",
        "browse_files": "procurar arquivos",
        "kb": "KB",
        "need_template": "Precisa de um modelo?",
        "download_template": "Baixar modelo CSV",
        "feature_not_enabled_title": "O recurso de gerenciamento de contatos não está ativado",
        "feature_not_enabled_desc": "Armazene os dados dos clientes em um catálogo de endereços compartilhado e convide contatos rapidamente para as sessões. Solicite ao seu administrador que ative este recurso.",
        "learn_more": "Saiba mais",
        "features_title": "Recursos de gerenciamento de contatos",
        "feature_shared_title": "Catálogo de endereços compartilhado",
        "feature_shared_desc": "Armazene e acesse os dados dos clientes em toda a sua equipe",
        "feature_invites_title": "Convites rápidos",
        "feature_invites_desc": "Selecione contatos ao criar uma sessão com preenchimento automático",
        "n_selected": "{n} selecionados",
        "one_selected": "{n} selecionado",
        "confirm_delete_contacts": "Tem certeza de que deseja excluir {n} contatos?",
        "confirm_delete_one_contact": "Tem certeza de que deseja excluir {n} contato?",
        "confirm_add_fav_contacts": "Tem certeza de que deseja adicionar {n} contatos aos favoritos?",
        "confirm_add_fav_one_contact": "Tem certeza de que deseja adicionar {n} contato aos favoritos?",
        "confirm_remove_fav_contacts": "Tem certeza de que deseja remover {n} contatos dos favoritos?",
        "confirm_remove_fav_one_contact": "Tem certeza de que deseja remover {n} contato dos favoritos?",
        "contacts_deleted": "{n} contatos excluídos",
        "one_contact_deleted": "{n} contato excluído",
        "contacts_exported": "{n} contatos exportados",
        "one_contact_exported": "{n} contato exportado",
        "rows_not_imported": "{n} linhas não puderam ser importadas",
        "one_row_not_imported": "{n} linha não pôde ser importada",
        "minutes_ago": "há {n} min",
        "hours_ago": "há {n} horas",
        "one_hour_ago": "há {n} hora",
        "days_ago": "há {n} dias",
        "one_day_ago": "há {n} dia",
        "weeks_ago": "há {n} semanas",
        "one_week_ago": "há {n} semana"
    },
    "pt_PT": {
        "contacts": "Contactos",
        "contacts_subtitle": "Faça a gestão do livro de endereços da sua empresa",
        "import": "Importar",
        "export": "Exportar",
        "add_contact": "Adicionar contacto",
        "import_contacts": "Importar contactos",
        "type_to_search": "Escreva para pesquisar",
        "all": "Todos",
        "name": "Nome",
        "phone": "Telefone",
        "email": "E-mail",
        "company": "Empresa",
        "notes": "Notas",
        "today": "Hoje",
        "this_week": "Esta semana",
        "this_month": "Este mês",
        "this_year": "Este ano",
        "filters": "Filtros",
        "filter_by": "Filtrar por",
        "reset_filters": "Repor filtros",
        "status": "Estado",
        "all_contacts": "Todos os contactos",
        "favorites_only": "Apenas favoritos",
        "created": "Criado",
        "created_at": "Criado em",
        "actions": "Ações",
        "bulk_actions": "Ações em massa",
        "add_to_favorites": "Adicionar aos favoritos",
        "remove_from_favorites": "Remover dos favoritos",
        "delete": "Eliminar",
        "delete_contact": "Eliminar contacto",
        "delete_contacts": "Eliminar contactos",
        "cancel": "Cancelar",
        "invite": "Convidar",
        "view_details": "Ver detalhes",
        "edit_contact": "Editar contacto",
        "not_available": "N/D",
        "just_now": "Agora mesmo",
        "no_contacts_yet": "Ainda não existem contactos",
        "empty_desc_can_add": "Adicione o seu primeiro contacto ou importe a partir de um ficheiro CSV",
        "empty_desc_view_only": "Ainda não foram adicionados contactos",
        "favorites": "Favoritos",
        "show": "Mostrar",
        "rows": "linhas",
        "no_favorites": "Sem favoritos",
        "no_favorites_yet": "Ainda não existem contactos favoritos. Marque contactos como favoritos para um acesso rápido.",
        "no_contacts_found": "Nenhum contacto encontrado",
        "all_are_favorites": "Todos os contactos estão marcados como favoritos.",
        "confirm_delete_named": "Tem a certeza de que pretende eliminar o contacto {name}?",
        "confirm_add_fav_named": "Tem a certeza de que pretende adicionar {name} aos favoritos?",
        "confirm_remove_fav_named": "Tem a certeza de que pretende remover {name} dos favoritos?",
        "contact_deleted": "Contacto eliminado",
        "error_occurred": "Ocorreu um erro",
        "added_to_favorites": "Adicionado aos favoritos",
        "removed_from_favorites": "Removido dos favoritos",
        "export_failed": "Falha na exportação",
        "contact_added": "Contacto adicionado",
        "contact_updated": "Contacto atualizado",
        "contacts_imported": "Contactos importados",
        "required_field": "Campo obrigatório",
        "enter_name": "Introduza o nome",
        "enter_company": "Introduza a empresa",
        "enter_phone": "Introduza o telefone",
        "enter_email": "Introduza o e-mail",
        "notes_placeholder": "Adicione notas sobre este contacto...",
        "mark_as_favorite": "Marcar como favorito",
        "add_another_after_save": "Adicionar outro contacto depois de guardar",
        "save_changes": "Guardar alterações",
        "name_required": "O nome é obrigatório",
        "name_min_length": "O nome deve ter pelo menos 1 carácter",
        "max_chars": "Até {n} caracteres permitidos",
        "invalid_email": "Endereço de e-mail inválido",
        "invalid_phone": "Número de telefone inválido",
        "phone_or_email_required": "O telefone ou o e-mail é obrigatório",
        "contact_details": "Detalhes do contacto",
        "label_copied": "Copiado: {label}",
        "close": "Fechar",
        "change": "Alterar",
        "select_from_contacts": "Selecionar dos contactos",
        "choose_contact_desc": "Escolha um contacto do seu livro de endereços",
        "select_contact_title": "Selecionar contacto",
        "picker_search_email": "Pesquise contactos ou introduza o e-mail...",
        "picker_search_phone": "Pesquise contactos ou introduza o número de telefone...",
        "loading_contacts": "A carregar contactos...",
        "no_contacts_found_for": "Nenhum contacto encontrado para \"{value}\"",
        "no_contacts_available": "Nenhum contacto disponível",
        "loading_more": "A carregar mais...",
        "add_new_contact": "Adicionar novo contacto",
        "continue": "Continuar",
        "invalid_file_type": "Tipo de ficheiro inválido. Carregue um ficheiro Excel (.xlsx) ou CSV (.csv).",
        "file_too_large": "O ficheiro é demasiado grande. O tamanho máximo é {n} MB.",
        "import_failed": "Falha na importação. Tente novamente.",
        "total": "Total",
        "imported": "Importados",
        "failed": "Com falha",
        "row": "Linha",
        "reason": "Motivo",
        "none_imported": "Não foi importado nenhum contacto. Verifique o seu ficheiro e tente novamente.",
        "done": "Concluído",
        "how_to_import": "Como importar contactos",
        "import_step_template": "Transfira o nosso modelo CSV para garantir a formatação correta",
        "import_step_required": "Campos obrigatórios: Nome completo, Número de telefone ou E-mail",
        "import_step_phone": "Se indicar o número de telefone, o código do país e o código ISO do país também são obrigatórios",
        "import_step_optional": "Campos opcionais: Empresa, Notas",
        "import_step_max_size": "Tamanho máximo do ficheiro: {n} MB (aproximadamente 10 000 contactos)",
        "drop_title": "Arraste e largue o seu ficheiro CSV aqui",
        "drop_or": "ou",
        "browse_files": "procurar ficheiros",
        "kb": "KB",
        "need_template": "Precisa de um modelo?",
        "download_template": "Transferir modelo CSV",
        "feature_not_enabled_title": "A funcionalidade de gestão de contactos não está ativada",
        "feature_not_enabled_desc": "Guarde os dados dos clientes num livro de endereços partilhado e convide rapidamente contactos para as sessões. Peça ao seu administrador para ativar esta funcionalidade.",
        "learn_more": "Saiba mais",
        "features_title": "Funcionalidades de gestão de contactos",
        "feature_shared_title": "Livro de endereços partilhado",
        "feature_shared_desc": "Guarde e aceda aos dados dos clientes em toda a sua equipa",
        "feature_invites_title": "Convites rápidos",
        "feature_invites_desc": "Selecione contactos ao criar uma sessão com preenchimento automático",
        "n_selected": "{n} selecionados",
        "one_selected": "{n} selecionado",
        "confirm_delete_contacts": "Tem a certeza de que pretende eliminar {n} contactos?",
        "confirm_delete_one_contact": "Tem a certeza de que pretende eliminar {n} contacto?",
        "confirm_add_fav_contacts": "Tem a certeza de que pretende adicionar {n} contactos aos favoritos?",
        "confirm_add_fav_one_contact": "Tem a certeza de que pretende adicionar {n} contacto aos favoritos?",
        "confirm_remove_fav_contacts": "Tem a certeza de que pretende remover {n} contactos dos favoritos?",
        "confirm_remove_fav_one_contact": "Tem a certeza de que pretende remover {n} contacto dos favoritos?",
        "contacts_deleted": "{n} contactos eliminados",
        "one_contact_deleted": "{n} contacto eliminado",
        "contacts_exported": "{n} contactos exportados",
        "one_contact_exported": "{n} contacto exportado",
        "rows_not_imported": "Não foi possível importar {n} linhas",
        "one_row_not_imported": "Não foi possível importar {n} linha",
        "minutes_ago": "há {n} min",
        "hours_ago": "há {n} horas",
        "one_hour_ago": "há {n} hora",
        "days_ago": "há {n} dias",
        "one_day_ago": "há {n} dia",
        "weeks_ago": "há {n} semanas",
        "one_week_ago": "há {n} semana"
    },
    "it_IT": {
        "contacts": "Contatti",
        "contacts_subtitle": "Gestisci la rubrica della tua azienda",
        "import": "Importa",
        "export": "Esporta",
        "add_contact": "Aggiungi contatto",
        "import_contacts": "Importa contatti",
        "type_to_search": "Digita per cercare",
        "all": "Tutti",
        "name": "Nome",
        "phone": "Telefono",
        "email": "E-mail",
        "company": "Azienda",
        "notes": "Note",
        "today": "Oggi",
        "this_week": "Questa settimana",
        "this_month": "Questo mese",
        "this_year": "Quest'anno",
        "filters": "Filtri",
        "filter_by": "Filtra per",
        "reset_filters": "Reimposta filtri",
        "status": "Stato",
        "all_contacts": "Tutti i contatti",
        "favorites_only": "Solo preferiti",
        "created": "Creato",
        "created_at": "Data di creazione",
        "actions": "Azioni",
        "bulk_actions": "Azioni di massa",
        "add_to_favorites": "Aggiungi ai preferiti",
        "remove_from_favorites": "Rimuovi dai preferiti",
        "delete": "Elimina",
        "delete_contact": "Elimina contatto",
        "delete_contacts": "Elimina contatti",
        "cancel": "Annulla",
        "invite": "Invita",
        "view_details": "Visualizza dettagli",
        "edit_contact": "Modifica contatto",
        "not_available": "N/D",
        "just_now": "Proprio ora",
        "no_contacts_yet": "Ancora nessun contatto",
        "empty_desc_can_add": "Aggiungi il tuo primo contatto o importa da un file CSV",
        "empty_desc_view_only": "Non è stato ancora aggiunto alcun contatto",
        "favorites": "Preferiti",
        "show": "Mostra",
        "rows": "righe",
        "no_favorites": "Nessun preferito",
        "no_favorites_yet": "Ancora nessun contatto preferito. Contrassegna i contatti come preferiti per accedervi rapidamente.",
        "no_contacts_found": "Nessun contatto trovato",
        "all_are_favorites": "Tutti i contatti sono contrassegnati come preferiti.",
        "confirm_delete_named": "Vuoi davvero eliminare il contatto {name}?",
        "confirm_add_fav_named": "Vuoi davvero aggiungere {name} ai preferiti?",
        "confirm_remove_fav_named": "Vuoi davvero rimuovere {name} dai preferiti?",
        "contact_deleted": "Contatto eliminato",
        "error_occurred": "Si è verificato un errore",
        "added_to_favorites": "Aggiunto ai preferiti",
        "removed_from_favorites": "Rimosso dai preferiti",
        "export_failed": "Esportazione non riuscita",
        "contact_added": "Contatto aggiunto",
        "contact_updated": "Contatto aggiornato",
        "contacts_imported": "Contatti importati",
        "required_field": "Campo obbligatorio",
        "enter_name": "Inserisci il nome",
        "enter_company": "Inserisci l'azienda",
        "enter_phone": "Inserisci il telefono",
        "enter_email": "Inserisci l'e-mail",
        "notes_placeholder": "Aggiungi note su questo contatto...",
        "mark_as_favorite": "Contrassegna come preferito",
        "add_another_after_save": "Aggiungi un altro contatto dopo il salvataggio",
        "save_changes": "Salva modifiche",
        "name_required": "Il nome è obbligatorio",
        "name_min_length": "Il nome deve contenere almeno 1 carattere",
        "max_chars": "Massimo {n} caratteri consentiti",
        "invalid_email": "Indirizzo e-mail non valido",
        "invalid_phone": "Numero di telefono non valido",
        "phone_or_email_required": "Telefono o e-mail obbligatorio",
        "contact_details": "Dettagli contatto",
        "label_copied": "Copiato: {label}",
        "close": "Chiudi",
        "change": "Cambia",
        "select_from_contacts": "Seleziona dai contatti",
        "choose_contact_desc": "Scegli un contatto dalla tua rubrica",
        "select_contact_title": "Seleziona contatto",
        "picker_search_email": "Cerca contatti o inserisci l'e-mail...",
        "picker_search_phone": "Cerca contatti o inserisci il numero di telefono...",
        "loading_contacts": "Caricamento contatti...",
        "no_contacts_found_for": "Nessun contatto trovato per \"{value}\"",
        "no_contacts_available": "Nessun contatto disponibile",
        "loading_more": "Caricamento di altri contatti...",
        "add_new_contact": "Aggiungi nuovo contatto",
        "continue": "Continua",
        "invalid_file_type": "Tipo di file non valido. Carica un file Excel (.xlsx) o CSV (.csv).",
        "file_too_large": "Il file è troppo grande. La dimensione massima è {n} MB.",
        "import_failed": "Importazione non riuscita. Riprova.",
        "total": "Totale",
        "imported": "Importati",
        "failed": "Non riusciti",
        "row": "Riga",
        "reason": "Motivo",
        "none_imported": "Nessun contatto è stato importato. Controlla il file e riprova.",
        "done": "Fine",
        "how_to_import": "Come importare i contatti",
        "import_step_template": "Scarica il nostro modello CSV per garantire la formattazione corretta",
        "import_step_required": "Campi obbligatori: Nome completo, Numero di telefono o E-mail",
        "import_step_phone": "Se è indicato il numero di telefono, sono obbligatori anche il prefisso internazionale e il codice ISO del paese",
        "import_step_optional": "Campi facoltativi: Azienda, Note",
        "import_step_max_size": "Dimensione massima del file: {n} MB (circa 10.000 contatti)",
        "drop_title": "Trascina qui il tuo file CSV",
        "drop_or": "oppure",
        "browse_files": "sfoglia i file",
        "kb": "KB",
        "need_template": "Ti serve un modello?",
        "download_template": "Scarica modello CSV",
        "feature_not_enabled_title": "La funzione Gestione contatti non è attiva",
        "feature_not_enabled_desc": "Memorizza i dati dei clienti in una rubrica condivisa e invita rapidamente i contatti alle sessioni. Chiedi al tuo amministratore di attivare questa funzione.",
        "learn_more": "Scopri di più",
        "features_title": "Funzioni di gestione dei contatti",
        "feature_shared_title": "Rubrica condivisa",
        "feature_shared_desc": "Memorizza e consulta i dati dei clienti in tutto il team",
        "feature_invites_title": "Inviti rapidi",
        "feature_invites_desc": "Seleziona i contatti durante la creazione della sessione con la compilazione automatica",
        "n_selected": "{n} selezionati",
        "one_selected": "{n} selezionato",
        "confirm_delete_contacts": "Vuoi davvero eliminare {n} contatti?",
        "confirm_delete_one_contact": "Vuoi davvero eliminare {n} contatto?",
        "confirm_add_fav_contacts": "Vuoi davvero aggiungere {n} contatti ai preferiti?",
        "confirm_add_fav_one_contact": "Vuoi davvero aggiungere {n} contatto ai preferiti?",
        "confirm_remove_fav_contacts": "Vuoi davvero rimuovere {n} contatti dai preferiti?",
        "confirm_remove_fav_one_contact": "Vuoi davvero rimuovere {n} contatto dai preferiti?",
        "contacts_deleted": "{n} contatti eliminati",
        "one_contact_deleted": "{n} contatto eliminato",
        "contacts_exported": "{n} contatti esportati",
        "one_contact_exported": "{n} contatto esportato",
        "rows_not_imported": "{n} righe non sono state importate",
        "one_row_not_imported": "{n} riga non è stata importata",
        "minutes_ago": "{n} min fa",
        "hours_ago": "{n} ore fa",
        "one_hour_ago": "{n} ora fa",
        "days_ago": "{n} giorni fa",
        "one_day_ago": "{n} giorno fa",
        "weeks_ago": "{n} settimane fa",
        "one_week_ago": "{n} settimana fa"
    },
    "zh_CN": {
        "contacts": "联系人",
        "contacts_subtitle": "管理公司通讯录",
        "import": "导入",
        "export": "导出",
        "add_contact": "添加联系人",
        "import_contacts": "导入联系人",
        "type_to_search": "输入以搜索",
        "all": "全部",
        "name": "姓名",
        "phone": "电话",
        "email": "电子邮件",
        "company": "公司",
        "notes": "备注",
        "today": "今天",
        "this_week": "本周",
        "this_month": "本月",
        "this_year": "今年",
        "filters": "筛选",
        "filter_by": "筛选条件",
        "reset_filters": "重置筛选",
        "status": "状态",
        "all_contacts": "所有联系人",
        "favorites_only": "仅收藏",
        "created": "创建时间",
        "created_at": "创建时间",
        "actions": "操作",
        "bulk_actions": "批量操作",
        "add_to_favorites": "添加到收藏",
        "remove_from_favorites": "从收藏中移除",
        "delete": "删除",
        "delete_contact": "删除联系人",
        "delete_contacts": "删除联系人",
        "cancel": "取消",
        "invite": "邀请",
        "view_details": "查看详情",
        "edit_contact": "编辑联系人",
        "not_available": "无",
        "just_now": "刚刚",
        "no_contacts_yet": "暂无联系人",
        "empty_desc_can_add": "添加您的第一个联系人，或从 CSV 文件导入",
        "empty_desc_view_only": "尚未添加任何联系人",
        "favorites": "收藏",
        "show": "显示",
        "rows": "行",
        "no_favorites": "暂无收藏",
        "no_favorites_yet": "暂无收藏的联系人。将联系人标记为收藏以便快速访问。",
        "no_contacts_found": "未找到联系人",
        "all_are_favorites": "所有联系人均已标记为收藏。",
        "confirm_delete_named": "确定要删除联系人 {name} 吗？",
        "confirm_add_fav_named": "确定要将 {name} 添加到收藏吗？",
        "confirm_remove_fav_named": "确定要将 {name} 从收藏中移除吗？",
        "contact_deleted": "联系人已删除",
        "error_occurred": "发生错误",
        "added_to_favorites": "已添加到收藏",
        "removed_from_favorites": "已从收藏中移除",
        "export_failed": "导出失败",
        "contact_added": "联系人已添加",
        "contact_updated": "联系人已更新",
        "contacts_imported": "联系人已导入",
        "required_field": "必填字段",
        "enter_name": "输入姓名",
        "enter_company": "输入公司",
        "enter_phone": "输入电话",
        "enter_email": "输入电子邮件",
        "notes_placeholder": "添加关于此联系人的备注...",
        "mark_as_favorite": "标记为收藏",
        "add_another_after_save": "保存后继续添加联系人",
        "save_changes": "保存更改",
        "name_required": "姓名为必填项",
        "name_min_length": "姓名至少需要 1 个字符",
        "max_chars": "最多允许 {n} 个字符",
        "invalid_email": "电子邮件地址无效",
        "invalid_phone": "电话号码无效",
        "phone_or_email_required": "电话或电子邮件为必填项",
        "contact_details": "联系人详情",
        "label_copied": "已复制{label}",
        "close": "关闭",
        "change": "更改",
        "select_from_contacts": "从联系人中选择",
        "choose_contact_desc": "从通讯录中选择一个联系人",
        "select_contact_title": "选择联系人",
        "picker_search_email": "搜索联系人或输入电子邮件...",
        "picker_search_phone": "搜索联系人或输入电话号码...",
        "loading_contacts": "正在加载联系人...",
        "no_contacts_found_for": "未找到与“{value}”匹配的联系人",
        "no_contacts_available": "没有可用的联系人",
        "loading_more": "正在加载更多...",
        "add_new_contact": "添加新联系人",
        "continue": "继续",
        "invalid_file_type": "文件类型无效。请上传 Excel (.xlsx) 或 CSV (.csv) 文件。",
        "file_too_large": "文件过大。最大大小为 {n} MB。",
        "import_failed": "导入失败。请重试。",
        "total": "总计",
        "imported": "已导入",
        "failed": "失败",
        "row": "行",
        "reason": "原因",
        "none_imported": "未导入任何联系人。请检查您的文件并重试。",
        "done": "完成",
        "how_to_import": "如何导入联系人",
        "import_step_template": "下载我们的 CSV 模板以确保格式正确",
        "import_step_required": "必填字段：全名、电话号码或电子邮件",
        "import_step_phone": "如果提供了电话号码，则国家/地区代码和国家/地区 ISO 代码也为必填项",
        "import_step_optional": "可选字段：公司、备注",
        "import_step_max_size": "最大文件大小：{n} MB（约 10,000 个联系人）",
        "drop_title": "将 CSV 文件拖放到此处",
        "drop_or": "或",
        "browse_files": "浏览文件",
        "kb": "KB",
        "need_template": "需要模板？",
        "download_template": "下载 CSV 模板",
        "feature_not_enabled_title": "联系人管理功能未启用",
        "feature_not_enabled_desc": "将客户详细信息存储在共享通讯录中，并快速邀请联系人加入会话。请联系管理员启用此功能。",
        "learn_more": "了解详情",
        "features_title": "联系人管理功能",
        "feature_shared_title": "共享通讯录",
        "feature_shared_desc": "在整个团队中存储和访问客户详细信息",
        "feature_invites_title": "快速邀请",
        "feature_invites_desc": "创建会话时选择联系人并自动填充",
        "n_selected": "已选择 {n} 项",
        "one_selected": "已选择 {n} 项",
        "confirm_delete_contacts": "确定要删除 {n} 个联系人吗？",
        "confirm_delete_one_contact": "确定要删除 {n} 个联系人吗？",
        "confirm_add_fav_contacts": "确定要将 {n} 个联系人添加到收藏吗？",
        "confirm_add_fav_one_contact": "确定要将 {n} 个联系人添加到收藏吗？",
        "confirm_remove_fav_contacts": "确定要将 {n} 个联系人从收藏中移除吗？",
        "confirm_remove_fav_one_contact": "确定要将 {n} 个联系人从收藏中移除吗？",
        "contacts_deleted": "已删除 {n} 个联系人",
        "one_contact_deleted": "已删除 {n} 个联系人",
        "contacts_exported": "已导出 {n} 个联系人",
        "one_contact_exported": "已导出 {n} 个联系人",
        "rows_not_imported": "{n} 行无法导入",
        "one_row_not_imported": "{n} 行无法导入",
        "minutes_ago": "{n} 分钟前",
        "hours_ago": "{n} 小时前",
        "one_hour_ago": "{n} 小时前",
        "days_ago": "{n} 天前",
        "one_day_ago": "{n} 天前",
        "weeks_ago": "{n} 周前",
        "one_week_ago": "{n} 周前"
    },
    "ja_JP": {
        "contacts": "連絡先",
        "contacts_subtitle": "会社のアドレス帳を管理します",
        "import": "インポート",
        "export": "エクスポート",
        "add_contact": "連絡先を追加",
        "import_contacts": "連絡先をインポート",
        "type_to_search": "入力して検索",
        "all": "すべて",
        "name": "名前",
        "phone": "電話",
        "email": "メール",
        "company": "会社",
        "notes": "メモ",
        "today": "今日",
        "this_week": "今週",
        "this_month": "今月",
        "this_year": "今年",
        "filters": "フィルター",
        "filter_by": "フィルター条件",
        "reset_filters": "フィルターをリセット",
        "status": "ステータス",
        "all_contacts": "すべての連絡先",
        "favorites_only": "お気に入りのみ",
        "created": "作成日",
        "created_at": "作成日時",
        "actions": "操作",
        "bulk_actions": "一括操作",
        "add_to_favorites": "お気に入りに追加",
        "remove_from_favorites": "お気に入りから削除",
        "delete": "削除",
        "delete_contact": "連絡先を削除",
        "delete_contacts": "連絡先を削除",
        "cancel": "キャンセル",
        "invite": "招待",
        "view_details": "詳細を表示",
        "edit_contact": "連絡先を編集",
        "not_available": "なし",
        "just_now": "たった今",
        "no_contacts_yet": "連絡先はまだありません",
        "empty_desc_can_add": "最初の連絡先を追加するか、CSV ファイルからインポートしてください",
        "empty_desc_view_only": "連絡先はまだ追加されていません",
        "favorites": "お気に入り",
        "show": "表示",
        "rows": "行",
        "no_favorites": "お気に入りはありません",
        "no_favorites_yet": "お気に入りの連絡先はまだありません。連絡先をお気に入りに登録すると、すばやくアクセスできます。",
        "no_contacts_found": "連絡先が見つかりません",
        "all_are_favorites": "すべての連絡先がお気に入りに登録されています。",
        "confirm_delete_named": "連絡先「{name}」を削除してもよろしいですか？",
        "confirm_add_fav_named": "{name} をお気に入りに追加してもよろしいですか？",
        "confirm_remove_fav_named": "{name} をお気に入りから削除してもよろしいですか？",
        "contact_deleted": "連絡先を削除しました",
        "error_occurred": "エラーが発生しました",
        "added_to_favorites": "お気に入りに追加しました",
        "removed_from_favorites": "お気に入りから削除しました",
        "export_failed": "エクスポートに失敗しました",
        "contact_added": "連絡先を追加しました",
        "contact_updated": "連絡先を更新しました",
        "contacts_imported": "連絡先をインポートしました",
        "required_field": "必須項目",
        "enter_name": "名前を入力",
        "enter_company": "会社を入力",
        "enter_phone": "電話番号を入力",
        "enter_email": "メールアドレスを入力",
        "notes_placeholder": "この連絡先に関するメモを追加...",
        "mark_as_favorite": "お気に入りに登録",
        "add_another_after_save": "保存後に別の連絡先を追加",
        "save_changes": "変更を保存",
        "name_required": "名前は必須です",
        "name_min_length": "名前は 1 文字以上で入力してください",
        "max_chars": "{n} 文字まで入力できます",
        "invalid_email": "メールアドレスが無効です",
        "invalid_phone": "電話番号が無効です",
        "phone_or_email_required": "電話番号またはメールアドレスが必要です",
        "contact_details": "連絡先の詳細",
        "label_copied": "{label}をコピーしました",
        "close": "閉じる",
        "change": "変更",
        "select_from_contacts": "連絡先から選択",
        "choose_contact_desc": "アドレス帳から連絡先を選択します",
        "select_contact_title": "連絡先を選択",
        "picker_search_email": "連絡先を検索、またはメールアドレスを入力...",
        "picker_search_phone": "連絡先を検索、または電話番号を入力...",
        "loading_contacts": "連絡先を読み込んでいます...",
        "no_contacts_found_for": "「{value}」に一致する連絡先は見つかりません",
        "no_contacts_available": "利用できる連絡先はありません",
        "loading_more": "さらに読み込んでいます...",
        "add_new_contact": "新しい連絡先を追加",
        "continue": "続行",
        "invalid_file_type": "ファイル形式が無効です。Excel (.xlsx) または CSV (.csv) ファイルをアップロードしてください。",
        "file_too_large": "ファイルが大きすぎます。最大サイズは {n} MB です。",
        "import_failed": "インポートに失敗しました。もう一度お試しください。",
        "total": "合計",
        "imported": "インポート済み",
        "failed": "失敗",
        "row": "行",
        "reason": "理由",
        "none_imported": "連絡先はインポートされませんでした。ファイルを確認して、もう一度お試しください。",
        "done": "完了",
        "how_to_import": "連絡先のインポート方法",
        "import_step_template": "正しい形式にするため、CSV テンプレートをダウンロードしてください",
        "import_step_required": "必須項目: 氏名、電話番号またはメールアドレス",
        "import_step_phone": "電話番号を入力する場合は、国番号と国の ISO コードも必須です",
        "import_step_optional": "任意項目: 会社、メモ",
        "import_step_max_size": "最大ファイルサイズ: {n} MB (約 10,000 件の連絡先)",
        "drop_title": "CSV ファイルをここにドラッグ＆ドロップ",
        "drop_or": "または",
        "browse_files": "ファイルを参照",
        "kb": "KB",
        "need_template": "テンプレートが必要ですか？",
        "download_template": "CSV テンプレートをダウンロード",
        "feature_not_enabled_title": "連絡先管理機能が有効になっていません",
        "feature_not_enabled_desc": "顧客の詳細を共有アドレス帳に保存し、連絡先をすばやくセッションに招待できます。この機能を有効にするよう管理者に依頼してください。",
        "learn_more": "詳細",
        "features_title": "連絡先管理機能",
        "feature_shared_title": "共有アドレス帳",
        "feature_shared_desc": "チーム全体で顧客の詳細を保存・参照",
        "feature_invites_title": "クイック招待",
        "feature_invites_desc": "セッション作成時に連絡先を選択して自動入力",
        "n_selected": "{n} 件選択中",
        "one_selected": "{n} 件選択中",
        "confirm_delete_contacts": "{n} 件の連絡先を削除してもよろしいですか？",
        "confirm_delete_one_contact": "{n} 件の連絡先を削除してもよろしいですか？",
        "confirm_add_fav_contacts": "{n} 件の連絡先をお気に入りに追加してもよろしいですか？",
        "confirm_add_fav_one_contact": "{n} 件の連絡先をお気に入りに追加してもよろしいですか？",
        "confirm_remove_fav_contacts": "{n} 件の連絡先をお気に入りから削除してもよろしいですか？",
        "confirm_remove_fav_one_contact": "{n} 件の連絡先をお気に入りから削除してもよろしいですか？",
        "contacts_deleted": "{n} 件の連絡先を削除しました",
        "one_contact_deleted": "{n} 件の連絡先を削除しました",
        "contacts_exported": "{n} 件の連絡先をエクスポートしました",
        "one_contact_exported": "{n} 件の連絡先をエクスポートしました",
        "rows_not_imported": "{n} 行をインポートできませんでした",
        "one_row_not_imported": "{n} 行をインポートできませんでした",
        "minutes_ago": "{n} 分前",
        "hours_ago": "{n} 時間前",
        "one_hour_ago": "{n} 時間前",
        "days_ago": "{n} 日前",
        "one_day_ago": "{n} 日前",
        "weeks_ago": "{n} 週間前",
        "one_week_ago": "{n} 週間前"
    },
    "pl_PL": {
        "contacts": "Kontakty",
        "contacts_subtitle": "Zarządzaj firmową książką adresową",
        "import": "Importuj",
        "export": "Eksportuj",
        "add_contact": "Dodaj kontakt",
        "import_contacts": "Importuj kontakty",
        "type_to_search": "Wpisz, aby wyszukać",
        "all": "Wszystkie",
        "name": "Imię i nazwisko",
        "phone": "Telefon",
        "email": "E-mail",
        "company": "Firma",
        "notes": "Notatki",
        "today": "Dzisiaj",
        "this_week": "Ten tydzień",
        "this_month": "Ten miesiąc",
        "this_year": "Ten rok",
        "filters": "Filtry",
        "filter_by": "Filtruj według",
        "reset_filters": "Resetuj filtry",
        "status": "Status",
        "all_contacts": "Wszystkie kontakty",
        "favorites_only": "Tylko ulubione",
        "created": "Utworzono",
        "created_at": "Data utworzenia",
        "actions": "Akcje",
        "bulk_actions": "Akcje zbiorcze",
        "add_to_favorites": "Dodaj do ulubionych",
        "remove_from_favorites": "Usuń z ulubionych",
        "delete": "Usuń",
        "delete_contact": "Usuń kontakt",
        "delete_contacts": "Usuń kontakty",
        "cancel": "Anuluj",
        "invite": "Zaproś",
        "view_details": "Wyświetl szczegóły",
        "edit_contact": "Edytuj kontakt",
        "not_available": "Brak",
        "just_now": "Przed chwilą",
        "no_contacts_yet": "Brak kontaktów",
        "empty_desc_can_add": "Dodaj pierwszy kontakt lub zaimportuj kontakty z pliku CSV",
        "empty_desc_view_only": "Nie dodano jeszcze żadnych kontaktów",
        "favorites": "Ulubione",
        "show": "Pokaż",
        "rows": "wierszy",
        "no_favorites": "Brak ulubionych",
        "no_favorites_yet": "Brak ulubionych kontaktów. Oznacz kontakty jako ulubione, aby mieć do nich szybki dostęp.",
        "no_contacts_found": "Nie znaleziono kontaktów",
        "all_are_favorites": "Wszystkie kontakty są oznaczone jako ulubione.",
        "confirm_delete_named": "Czy na pewno chcesz usunąć kontakt {name}?",
        "confirm_add_fav_named": "Czy na pewno chcesz dodać {name} do ulubionych?",
        "confirm_remove_fav_named": "Czy na pewno chcesz usunąć {name} z ulubionych?",
        "contact_deleted": "Kontakt został usunięty",
        "error_occurred": "Wystąpił błąd",
        "added_to_favorites": "Dodano do ulubionych",
        "removed_from_favorites": "Usunięto z ulubionych",
        "export_failed": "Eksport nie powiódł się",
        "contact_added": "Kontakt został dodany",
        "contact_updated": "Kontakt został zaktualizowany",
        "contacts_imported": "Kontakty zostały zaimportowane",
        "required_field": "Pole wymagane",
        "enter_name": "Wpisz imię i nazwisko",
        "enter_company": "Wpisz firmę",
        "enter_phone": "Wpisz telefon",
        "enter_email": "Wpisz e-mail",
        "notes_placeholder": "Dodaj notatki o tym kontakcie...",
        "mark_as_favorite": "Oznacz jako ulubiony",
        "add_another_after_save": "Dodaj kolejny kontakt po zapisaniu",
        "save_changes": "Zapisz zmiany",
        "name_required": "Imię i nazwisko jest wymagane",
        "name_min_length": "Imię i nazwisko musi mieć co najmniej 1 znak",
        "max_chars": "Dozwolona liczba znaków: maksymalnie {n}",
        "invalid_email": "Nieprawidłowy adres e-mail",
        "invalid_phone": "Nieprawidłowy numer telefonu",
        "phone_or_email_required": "Wymagany jest telefon lub e-mail",
        "contact_details": "Szczegóły kontaktu",
        "label_copied": "Skopiowano: {label}",
        "close": "Zamknij",
        "change": "Zmień",
        "select_from_contacts": "Wybierz z kontaktów",
        "choose_contact_desc": "Wybierz kontakt z książki adresowej",
        "select_contact_title": "Wybierz kontakt",
        "picker_search_email": "Wyszukaj kontakty lub wpisz e-mail...",
        "picker_search_phone": "Wyszukaj kontakty lub wpisz numer telefonu...",
        "loading_contacts": "Ładowanie kontaktów...",
        "no_contacts_found_for": "Nie znaleziono kontaktów dla „{value}”",
        "no_contacts_available": "Brak dostępnych kontaktów",
        "loading_more": "Ładowanie kolejnych...",
        "add_new_contact": "Dodaj nowy kontakt",
        "continue": "Kontynuuj",
        "invalid_file_type": "Nieprawidłowy typ pliku. Prześlij plik Excel (.xlsx) lub CSV (.csv).",
        "file_too_large": "Plik jest za duży. Maksymalny rozmiar to {n} MB.",
        "import_failed": "Import nie powiódł się. Spróbuj ponownie.",
        "total": "Łącznie",
        "imported": "Zaimportowano",
        "failed": "Niepowodzenia",
        "row": "Wiersz",
        "reason": "Powód",
        "none_imported": "Nie zaimportowano żadnych kontaktów. Sprawdź plik i spróbuj ponownie.",
        "done": "Gotowe",
        "how_to_import": "Jak zaimportować kontakty",
        "import_step_template": "Pobierz nasz szablon CSV, aby zapewnić prawidłowe formatowanie",
        "import_step_required": "Pola wymagane: Imię i nazwisko, Numer telefonu lub E-mail",
        "import_step_phone": "Jeśli podano numer telefonu, wymagane są również kod kraju i kod ISO kraju",
        "import_step_optional": "Pola opcjonalne: Firma, Notatki",
        "import_step_max_size": "Maksymalny rozmiar pliku: {n} MB (około 10 000 kontaktów)",
        "drop_title": "Przeciągnij i upuść tutaj plik CSV",
        "drop_or": "lub",
        "browse_files": "przeglądaj pliki",
        "kb": "KB",
        "need_template": "Potrzebujesz szablonu?",
        "download_template": "Pobierz szablon CSV",
        "feature_not_enabled_title": "Funkcja zarządzania kontaktami nie jest włączona",
        "feature_not_enabled_desc": "Przechowuj dane klientów we wspólnej książce adresowej i szybko zapraszaj kontakty do sesji. Poproś administratora o włączenie tej funkcji.",
        "learn_more": "Dowiedz się więcej",
        "features_title": "Funkcje zarządzania kontaktami",
        "feature_shared_title": "Wspólna książka adresowa",
        "feature_shared_desc": "Przechowuj dane klientów i korzystaj z nich w całym zespole",
        "feature_invites_title": "Szybkie zaproszenia",
        "feature_invites_desc": "Wybieraj kontakty podczas tworzenia sesji z automatycznym uzupełnianiem",
        "n_selected": "Wybrano: {n}",
        "one_selected": "Wybrano: {n}",
        "confirm_delete_contacts": "Czy na pewno chcesz usunąć wybrane kontakty ({n})?",
        "confirm_delete_one_contact": "Czy na pewno chcesz usunąć {n} kontakt?",
        "confirm_add_fav_contacts": "Czy na pewno chcesz dodać wybrane kontakty ({n}) do ulubionych?",
        "confirm_add_fav_one_contact": "Czy na pewno chcesz dodać {n} kontakt do ulubionych?",
        "confirm_remove_fav_contacts": "Czy na pewno chcesz usunąć wybrane kontakty ({n}) z ulubionych?",
        "confirm_remove_fav_one_contact": "Czy na pewno chcesz usunąć {n} kontakt z ulubionych?",
        "contacts_deleted": "Usunięto kontakty: {n}",
        "one_contact_deleted": "Usunięto {n} kontakt",
        "contacts_exported": "Wyeksportowano kontakty: {n}",
        "one_contact_exported": "Wyeksportowano {n} kontakt",
        "rows_not_imported": "Nie udało się zaimportować wierszy: {n}",
        "one_row_not_imported": "Nie udało się zaimportować {n} wiersza",
        "minutes_ago": "{n} min temu",
        "hours_ago": "{n} godz. temu",
        "one_hour_ago": "{n} godzinę temu",
        "days_ago": "{n} dni temu",
        "one_day_ago": "{n} dzień temu",
        "weeks_ago": "{n} tyg. temu",
        "one_week_ago": "{n} tydzień temu"
    },
    "ko_KR": {
        "contacts": "연락처",
        "contacts_subtitle": "회사 주소록을 관리합니다",
        "import": "가져오기",
        "export": "내보내기",
        "add_contact": "연락처 추가",
        "import_contacts": "연락처 가져오기",
        "type_to_search": "검색어 입력",
        "all": "전체",
        "name": "이름",
        "phone": "전화",
        "email": "이메일",
        "company": "회사",
        "notes": "메모",
        "today": "오늘",
        "this_week": "이번 주",
        "this_month": "이번 달",
        "this_year": "올해",
        "filters": "필터",
        "filter_by": "필터 기준",
        "reset_filters": "필터 초기화",
        "status": "상태",
        "all_contacts": "모든 연락처",
        "favorites_only": "즐겨찾기만",
        "created": "생성일",
        "created_at": "생성 일시",
        "actions": "작업",
        "bulk_actions": "일괄 작업",
        "add_to_favorites": "즐겨찾기에 추가",
        "remove_from_favorites": "즐겨찾기에서 제거",
        "delete": "삭제",
        "delete_contact": "연락처 삭제",
        "delete_contacts": "연락처 삭제",
        "cancel": "취소",
        "invite": "초대",
        "view_details": "세부 정보 보기",
        "edit_contact": "연락처 편집",
        "not_available": "없음",
        "just_now": "방금 전",
        "no_contacts_yet": "아직 연락처가 없습니다",
        "empty_desc_can_add": "첫 번째 연락처를 추가하거나 CSV 파일에서 가져오세요",
        "empty_desc_view_only": "아직 추가된 연락처가 없습니다",
        "favorites": "즐겨찾기",
        "show": "표시",
        "rows": "행",
        "no_favorites": "즐겨찾기 없음",
        "no_favorites_yet": "아직 즐겨찾기한 연락처가 없습니다. 연락처를 즐겨찾기로 표시하면 빠르게 액세스할 수 있습니다.",
        "no_contacts_found": "연락처를 찾을 수 없습니다",
        "all_are_favorites": "모든 연락처가 즐겨찾기로 표시되어 있습니다.",
        "confirm_delete_named": "{name} 연락처를 삭제하시겠습니까?",
        "confirm_add_fav_named": "{name}을(를) 즐겨찾기에 추가하시겠습니까?",
        "confirm_remove_fav_named": "{name}을(를) 즐겨찾기에서 제거하시겠습니까?",
        "contact_deleted": "연락처가 삭제되었습니다",
        "error_occurred": "오류가 발생했습니다",
        "added_to_favorites": "즐겨찾기에 추가되었습니다",
        "removed_from_favorites": "즐겨찾기에서 제거되었습니다",
        "export_failed": "내보내기에 실패했습니다",
        "contact_added": "연락처가 추가되었습니다",
        "contact_updated": "연락처가 업데이트되었습니다",
        "contacts_imported": "연락처를 가져왔습니다",
        "required_field": "필수 입력란",
        "enter_name": "이름 입력",
        "enter_company": "회사 입력",
        "enter_phone": "전화번호 입력",
        "enter_email": "이메일 입력",
        "notes_placeholder": "이 연락처에 대한 메모 추가...",
        "mark_as_favorite": "즐겨찾기로 표시",
        "add_another_after_save": "저장 후 다른 연락처 추가",
        "save_changes": "변경 사항 저장",
        "name_required": "이름은 필수입니다",
        "name_min_length": "이름은 1자 이상이어야 합니다",
        "max_chars": "최대 {n}자까지 입력할 수 있습니다",
        "invalid_email": "잘못된 이메일 주소입니다",
        "invalid_phone": "잘못된 전화번호입니다",
        "phone_or_email_required": "전화번호 또는 이메일이 필요합니다",
        "contact_details": "연락처 세부 정보",
        "label_copied": "{label} 복사됨",
        "close": "닫기",
        "change": "변경",
        "select_from_contacts": "연락처에서 선택",
        "choose_contact_desc": "주소록에서 연락처를 선택하세요",
        "select_contact_title": "연락처 선택",
        "picker_search_email": "연락처 검색 또는 이메일 입력...",
        "picker_search_phone": "연락처 검색 또는 전화번호 입력...",
        "loading_contacts": "연락처를 불러오는 중...",
        "no_contacts_found_for": "\"{value}\"에 대한 연락처를 찾을 수 없습니다",
        "no_contacts_available": "사용 가능한 연락처가 없습니다",
        "loading_more": "더 불러오는 중...",
        "add_new_contact": "새 연락처 추가",
        "continue": "계속",
        "invalid_file_type": "잘못된 파일 형식입니다. Excel(.xlsx) 또는 CSV(.csv) 파일을 업로드하세요.",
        "file_too_large": "파일이 너무 큽니다. 최대 크기는 {n}MB입니다.",
        "import_failed": "가져오기에 실패했습니다. 다시 시도하세요.",
        "total": "전체",
        "imported": "가져옴",
        "failed": "실패",
        "row": "행",
        "reason": "사유",
        "none_imported": "가져온 연락처가 없습니다. 파일을 확인하고 다시 시도하세요.",
        "done": "완료",
        "how_to_import": "연락처 가져오기 방법",
        "import_step_template": "올바른 형식을 위해 CSV 템플릿을 다운로드하세요",
        "import_step_required": "필수 입력란: 전체 이름, 전화번호 또는 이메일",
        "import_step_phone": "전화번호를 입력한 경우 국가 코드와 국가 ISO 코드도 필수입니다",
        "import_step_optional": "선택 입력란: 회사, 메모",
        "import_step_max_size": "최대 파일 크기: {n}MB(약 10,000개 연락처)",
        "drop_title": "CSV 파일을 여기로 끌어다 놓으세요",
        "drop_or": "또는",
        "browse_files": "파일 찾아보기",
        "kb": "KB",
        "need_template": "템플릿이 필요하신가요?",
        "download_template": "CSV 템플릿 다운로드",
        "feature_not_enabled_title": "연락처 관리 기능이 활성화되지 않았습니다",
        "feature_not_enabled_desc": "고객 정보를 공유 주소록에 저장하고 연락처를 세션에 빠르게 초대하세요. 관리자에게 이 기능을 활성화해 달라고 요청하세요.",
        "learn_more": "자세히 알아보기",
        "features_title": "연락처 관리 기능",
        "feature_shared_title": "공유 주소록",
        "feature_shared_desc": "팀 전체에서 고객 정보 저장 및 액세스",
        "feature_invites_title": "빠른 초대",
        "feature_invites_desc": "세션 생성 시 연락처를 선택하여 자동 입력",
        "n_selected": "{n}개 선택됨",
        "one_selected": "{n}개 선택됨",
        "confirm_delete_contacts": "연락처 {n}개를 삭제하시겠습니까?",
        "confirm_delete_one_contact": "연락처 {n}개를 삭제하시겠습니까?",
        "confirm_add_fav_contacts": "연락처 {n}개를 즐겨찾기에 추가하시겠습니까?",
        "confirm_add_fav_one_contact": "연락처 {n}개를 즐겨찾기에 추가하시겠습니까?",
        "confirm_remove_fav_contacts": "연락처 {n}개를 즐겨찾기에서 제거하시겠습니까?",
        "confirm_remove_fav_one_contact": "연락처 {n}개를 즐겨찾기에서 제거하시겠습니까?",
        "contacts_deleted": "연락처 {n}개가 삭제되었습니다",
        "one_contact_deleted": "연락처 {n}개가 삭제되었습니다",
        "contacts_exported": "연락처 {n}개를 내보냈습니다",
        "one_contact_exported": "연락처 {n}개를 내보냈습니다",
        "rows_not_imported": "{n}개 행을 가져올 수 없습니다",
        "one_row_not_imported": "{n}개 행을 가져올 수 없습니다",
        "minutes_ago": "{n}분 전",
        "hours_ago": "{n}시간 전",
        "one_hour_ago": "{n}시간 전",
        "days_ago": "{n}일 전",
        "one_day_ago": "{n}일 전",
        "weeks_ago": "{n}주 전",
        "one_week_ago": "{n}주 전"
    }
};
